// /* eslint-disable @typescript-eslint/no-unused-vars */

import { HIT_BOARD_STATUSV2 } from '_revamp/redux/action/admin/board';
import {
  all, call, put, takeEvery, select,
  delay,
} from 'redux-saga/effects';
import {
  HIT_COMPANY_REGISTER,
  HIT_FORGOT_PASS,
  HIT_REGISTER,
  HIT_RESET,
} from 'redux/actions/auth';
import {
  GET_LIST_MEMBER_BOARD,
  HIT_ADD_BOARD,
  HIT_BOARD_STATUS,
  HIT_DELETE_BOARD,
  HIT_DUPLICATE_BOARD,
  HIT_INVITE_BOARD,
  HIT_LIST_MEMBER_BOARD,
  HIT_UPDATE_BOARD,
} from 'redux/actions/board';

// Import all actions
import { GET_LIST_BOARD, HIT_LIST_BOARD } from 'redux/actions/board';
import {
  GET_COMPETENCY_INQUIRY,
  GET_COMPETENCY_LIB,
  GET_COP_LIST,
  GET_CUSTOM_MANAGEMENT,
  GET_DETAIL_COMPANY,
  GET_DETAIL_COMPETENCY,
  GET_LIST_LEVEL_DESCRIPTION,
  GET_LIST_MEMBER,
  GET_LIST_SKILL_GROUP,
  GET_LIST_SUB_SKILL_GROUP,
  GET_LIST_SUB_SKILL_GROUP_MULTIPLE,
  GET_UPDATE_SUB_SKILL_GROUP_MULTIPLE,
  HIT_ACTION_SKILL_GROUP,
  HIT_ACTIVITY_MOVE_ORDER,
  HIT_ACTIVITY_TYPE_CREATE,
  HIT_ACTIVITY_TYPE_UPDATE,
  HIT_COMPETENCY_DELETE,
  HIT_COMPETENCY_IMPORT,
  HIT_COMPETENCY_INQUIRY,
  HIT_COMPETENCY_LIB,
  HIT_COMPETENCY_LIB_CREATE,
  HIT_COMPETENCY_LIB_UPDATE,
  HIT_COMPETENCY_MOVE,
  HIT_COP_CREATE,
  HIT_COP_LIST,
  HIT_COP_UPDATE,
  HIT_CREATE_LEVEL_DESCRIPTION,
  HIT_CUSTOM_MANAGEMENT,
  HIT_CUSTOM_MANAGEMENT_CREATE,
  HIT_CUSTOM_MANAGEMENT_UPDATE,
  HIT_DETAIL_COMPANY,
  HIT_DETAIL_COMPETENCY,
  HIT_FTE_LIMIT_MOVE_ORDER,
  HIT_INVITE_MEMBER,
  HIT_LIST_LEVEL_DESCRIPTION,
  HIT_LIST_MEMBER,
  HIT_LIST_SKILL_GROUP,
  HIT_LIST_SUB_SKILL_GROUP,
  HIT_UPDATE_CP,
  HIT_UPDATE_LEVEL_DESCRIPTION,
} from 'redux/actions/company';
import { GET_CVC_LVL_1, HIT_CVC_LVL_1 } from 'redux/actions/cvc';
import {
  DO_LOADING,
  DO_SWITCH_OFF,
  DO_SWITCH_ON,
  DO_TRIGGER,
  POP_UP,
} from 'redux/actions/loading';
import {
  apiForgotPass,
  apiLogin,
  apiRegisterCompanyMember,
} from 'redux/api/auth';
import {
  apiCreateBoard,
  apiDeleteBoard,
  apiDuplicateBoard,
  apiInviteBoard,
  apiListBoard,
  apiListMemberBoard,
  apiUpdateBoard,
} from 'redux/api/board';
// Import all actions

// Import api call
import { GET_LOGIN, HIT_LOGIN } from 'redux/actions/auth';
import {
  EXPORT_BO_EMPLOYEE_REQUEST,
  EXPORT_BO_EMPLOYEE_SUCCESS,
  EXPORT_BO_STRUCTURE_REQUEST,
  EXPORT_BO_STRUCTURE_SUCCESS,
  GET_BACKOFFICE_LIST,
  GET_BO_ACTIVITY_TYPE,
  GET_BO_APQC,
  GET_BO_APQC_LIB,
  GET_BO_BOARD_EMPLOYEE,
  GET_BO_BOARD_PROCESS,
  GET_BO_BOARD_STRUCTURE,
  GET_BO_CATEGORY_GROUP,
  GET_BO_CLASSIFICATION,
  GET_BO_COMPANY_BOARD,
  GET_BO_COMPETENCY_DETAIL,
  GET_BO_COMPETENCY_LIBRARY,
  GET_BO_CUSTOM_ORG_PARAMETER,
  GET_BO_DASHBOARD,
  GET_BO_DETAIL_STRUCTURE,
  GET_BO_DIRECTORATE,
  GET_BO_FEATURE,
  GET_BO_FTE,
  GET_BO_JOB_LEVEL,
  GET_BO_LEVEL_DESCRIPTION,
  GET_BO_LOG_LIST,
  GET_BO_LOG_LIST_FEATURE,
  GET_BO_MEMBER,
  GET_BO_REGION,
  GET_BO_SKILL_GROUP,
  GET_BO_SUBSCRIPTION_LIST,
  GET_BO_SUB_SKILL_GROUP,
  GET_BO_USER_LIST,
  GET_BO_WORKER_TYPE,
  GET_COMPETENCY,
  GET_WORKLOAD_LIST,
  HIT_BACKOFFICE_LIST,
  HIT_BO_ACTIVITY_TYPE,
  HIT_BO_APQC,
  HIT_BO_APQC_CREATE,
  HIT_BO_APQC_IMPORT,
  HIT_BO_APQC_LIB,
  HIT_BO_APQC_MOVE,
  HIT_BO_APQC_UPDATE,
  HIT_BO_APQC_UPDATE_LIBRARY,
  HIT_BO_BOARD_EMPLOYEE,
  HIT_BO_BOARD_PROCESS,
  HIT_BO_BOARD_STRUCTURE,
  HIT_BO_CATEGORY_GROUP,
  HIT_BO_CLASSIFICATION,
  HIT_BO_COMPANY_BOARD,
  HIT_BO_COMPANY_DELETE,
  HIT_BO_COMPETENCY_DETAIL,
  HIT_BO_COMPETENCY_LIBRARY,
  HIT_BO_CREATE_STRUCTURE,
  HIT_BO_CUSTOM_ORG_PARAMETER,
  HIT_BO_DASHBOARD,
  HIT_BO_DETAIL_STRUCTURE,
  HIT_BO_DIRECTORATE,
  HIT_BO_FEATURE,
  HIT_BO_FTE,
  HIT_BO_IMPORT_ADD_ORGANIZATION,
  HIT_BO_IMPORT_ANOTHER_BOARD_EMPLOYEE,
  HIT_BO_IMPORT_ANOTHER_BOARD_STRUCTURE,
  HIT_BO_IMPORT_UPDATE_EMPLOYEE,
  HIT_BO_IMPORT_UPDATE_STRUCTURE,
  HIT_BO_JOB_LEVEL,
  HIT_BO_LEVEL_DESCRIPTION,
  HIT_BO_LOG_LIST,
  HIT_BO_LOG_LIST_FEATURE,
  HIT_BO_MEMBER,
  HIT_BO_REGION,
  HIT_BO_REPORT_TO,
  HIT_BO_SKILL_GROUP,
  HIT_BO_SUBSCRIPTION_LIST,
  HIT_BO_SUBS_CREATE,
  HIT_BO_SUBS_UPDATE,
  HIT_BO_SUB_SKILL_GROUP,
  HIT_BO_UPDATE_BOARD,
  HIT_BO_UPDATE_EMPLOYEE,
  HIT_BO_UPDATE_STRUCTURE,
  HIT_BO_USER_CREATE,
  HIT_BO_USER_LIST,
  HIT_BO_USER_UPDATE,
  HIT_BO_WORKER_TYPE,
  HIT_COMPETENCY,
  HIT_COMPETENCY_CREATE,
  HIT_COMPETENCY_UPDATE,
  HIT_WORKLOAD_LIST,
} from 'redux/actions/backOffice';
import {
  GET_APQC_LIB,
  GET_APQC_TEMPLATE,
  GET_APQC_VER,
  GET_DETAIL_BS,
  GET_HIERARCHY,
  GET_INDEX_VIEW,
  GET_LIST_PROCESS_LEVEL,
  GET_TREE_VIEW,
  HIT_ADD_APQC,
  HIT_ADD_TREE,
  HIT_APQC_LIB,
  HIT_APQC_TEMPLATE,
  HIT_APQC_VER,
  HIT_CREATE_BS,
  HIT_CREATE_CHILD,
  HIT_DELETE_PROCESS,
  HIT_DETAIL_BS,
  HIT_HIERARCHY,
  HIT_IMPORT_PROCESS,
  HIT_IMPORT_PROCESS_COPY,
  HIT_INDEX_VIEW,
  HIT_LIST_PROCESS_LEVEL,
  HIT_MOVE_TREE,
  HIT_TREE_VIEW,
  HIT_UPDATE_BS,
} from 'redux/actions/business_process';
import {
  GET_DASHBOARD,
  GET_DASHBOARD_COUNT,
  HIT_DASHBOARD,
  HIT_DASHBOARD_COUNT,
} from 'redux/actions/dashboard';
import {
  GET_AUTHORITY_JOBDESC,
  GET_DETAIL_JOBDESC,
  GET_DETAIL_JOBDESC_V2,
  GET_KPI_JOBDESC,
  GET_LIST_JOBDESC,
  GET_LIST_JOBDESC_LIMIT,
  GET_LIST_VERSIONID,
  GET_MAINRESPO_JOBDESC,
  GET_ORG_STRUCTURE_JOBDESC,
  GET_WORK_RELATION_JOBDESC,
  HIT_AUTHORITY_JOBDESC,
  HIT_DETAIL_JOBDESC,
  HIT_DETAIL_JOBDESC_V2,
  HIT_HR_APPROVAL,
  HIT_KPI_JOBDESC,
  HIT_LIST_JOBDESC,
  HIT_LIST_VERSIONID,
  HIT_MAINRESPO_JOBDESC,
  HIT_ORG_STRUCTURE_JOBDESC,
  HIT_WORK_RELATION_JOBDESC,
} from 'redux/actions/jobdesc';
import {
  GET_LIST_CONFLICT,
  GET_LIST_PERIOD,
  GET_MATRIX_STATUS,
  GET_MATRIX_STRUCTURE_STATUS,
  GET_NEW_VIEW_MATRIX,
  GET_PIVOT_DATA,
  GET_VIEW_MATRIX,
  GET_VIEW_MATRIX_FOCUS,
  HIT_CHANGE_MATRIX,
  HIT_CLOSED_MATRIX,
  HIT_CREATE_MATRIX,
  HIT_IMPORT_MATRIX,
  HIT_LIST_CONFLICT,
  HIT_LIST_PERIOD,
  HIT_MATRIX_STRUCTURE_STATUS,
  HIT_MERGE_MATRIX,
  HIT_NEW_VIEW_MATRIX,
  HIT_PIVOT_DATA,
  HIT_VIEW_MATRIX,
  HIT_MATRIX_VIEW_STRUCTURE,
  HIT_MATRIX_VIEW_PROCESS,
  GET_MATRIX_VIEW_PROCESS,
  GET_MATRIX_ACTIVE_PERIOD,
  GET_VIEW_MATRIX_FOCUS_CHANGE,
  HIT_SELECTED_MATRIX_FOCUS,
  GET_SELECTED_MATRIX_FOCUS,
  HIT_VIEW_DETAIL_OF_PROCESS,
  GET_VIEW_DETAIL_OF_PROCESS,
  GET_MATRIX_VIEW_STRUCTURE,
} from 'redux/actions/matrix';
import {
  GET_BANK_LIST,
  GET_DETAIL_STRUCTURE,
  GET_EMPLOYEE_CHART,
  GET_FOCUS_POSITION,
  GET_FOCUS_POSITION_EMPLOYEE,
  GET_LIST_DIRECTORATE,
  GET_LIST_DIVISION,
  GET_LIST_EMPLOYEE,
  GET_LIST_EMPLOYEE_LIMIT,
  GET_LIST_JOB,
  GET_LIST_ORGANIZATION,
  GET_LIST_ORGANIZATION_LIMIT,
  GET_STRUCTURE,
  HIT_ADD_EMPLOYEE,
  HIT_ADD_NODE_EMPLOYEE,
  HIT_ADD_NODE_STRUCTURE,
  HIT_ADD_STRUCTURE,
  HIT_BANK_LIST,
  HIT_CREATE_DIRECTORATE,
  HIT_CREATE_EMPLOYEE,
  HIT_CREATE_JOB_LEVEL,
  HIT_CREATE_STRUCTURE_COPY,
  HIT_DELETE_DIRECTORATE,
  HIT_DETAIL_STRUCTURE,
  HIT_EDIT_EMPLOYEE,
  HIT_EMPLOYEE_CHART,
  HIT_FOCUS_POSITION,
  HIT_FOCUS_POSITION_EMPLOYEE,
  HIT_IMPORT_PROCESS_ORG,
  HIT_LIST_DIRECTORATE,
  HIT_LIST_DIVISION,
  HIT_LIST_EMPLOYEE,
  HIT_LIST_JOB,
  HIT_LIST_ORGANIZATION,
  HIT_REGION_CREATE,
  HIT_REGION_UPDATE,
  HIT_STRUCTURE,
  HIT_UPDATE_DIRECTORATE,
  HIT_UPDATE_EMPLOYEE,
  HIT_UPDATE_JOB_LEVEL,
  HIT_UPDATE_NODE_EMPLOYEE,
  HIT_UPDATE_STRUCTURE,
} from 'redux/actions/organization';
import {
  GET_PROFILE,
  HIT_PROFILE,
  HIT_UPDATE_PROFILE,
} from 'redux/actions/profile';
import {
  VALIDATION_ALL_STORE,
  VALIDATION_COMPANY,
  VALIDATION_DASHBOARD,
  VALIDATION_MATRIX,
} from 'redux/actions/validationRole';
import {
  GET_ACTIVITY_TYPE_LIST,
  GET_EXPORT_DATA_ACTIVITY,
  GET_EXPORT_DATA_OVERALL,
  GET_LIST_CUSTOM_CATEGORY,
  GET_LIST_LIMIT_FTE,
  GET_REGION_LIST,
  GET_STRUCTURE_EMPLOYEE,
  GET_VALIDATION_WLA,
  GET_WLA_BAR_CHART,
  GET_WLA_CHART_PROCESS,
  GET_WLA_DASHBOARD_DEPARTEMENT,
  GET_WLA_DASHBOARD_DIVISION,
  GET_WLA_DASHBOARD_EMPLOYEE,
  GET_WLA_DASHBOARD_EMPLOYEE_REGION,
  GET_WLA_DASHBOARD_JOBLVL,
  GET_WLA_DETAIL,
  GET_WLA_DETAIL_ORG,
  GET_WLA_DETAIL_STRUCTURE,
  GET_WLA_LIST,
  GET_WLA_LIST_PROCESS,
  GET_WLA_LIST_TEMPLATE,
  GET_WLA_OC_BOARD,
  GET_WLA_OC_DEPARTEMENT,
  GET_WLA_OC_EMPLOYEE,
  GET_WLA_OC_LIST,
  GET_WLA_OC_ORG,
  GET_WLA_ORG_PROCESS,
  GET_WLA_PROGRESS_SUMMARY,
  GET_WORKER_TYPE_LIST,
  HIT_ACTIVITY_TYPE_LIST,
  HIT_CREATE_FTE,
  HIT_EXPORT_DATA_ACTIVITY,
  HIT_EXPORT_DATA_OVERALL,
  HIT_LIST_CUSTOM_CATEGORY,
  HIT_LIST_LIMIT_FTE,
  HIT_LIST_LIMIT_FTE_PUBLIC,
  HIT_ON_SAVE_WLA,
  HIT_REGION_LIST,
  HIT_STRUCTURE_EMPLOYEE,
  HIT_UPDATE_FTE,
  HIT_VALIDATION_WLA,
  HIT_WLA_ASSESSMENT,
  HIT_WLA_BAR_CHART,
  HIT_WLA_CHART_PROCESS,
  HIT_WLA_DASHBOARD_DEPARTEMENT,
  HIT_WLA_DASHBOARD_DIVISION,
  HIT_WLA_DASHBOARD_EMPLOYEE,
  HIT_WLA_DASHBOARD_EMPLOYEE_REGION,
  HIT_WLA_DASHBOARD_JOBLVL,
  HIT_WLA_DETAIL,
  HIT_WLA_DETAIL_ORG,
  HIT_WLA_DETAIL_STRUCTURE,
  HIT_WLA_LIST,
  HIT_WLA_LIST_PROCESS,
  HIT_WLA_LIST_TEMPLATE,
  HIT_WLA_OC_BOARD,
  HIT_WLA_OC_CREATE,
  HIT_WLA_OC_DEPARTEMENT,
  HIT_WLA_OC_EMPLOYEE,
  HIT_WLA_OC_LIST,
  HIT_WLA_OC_ORG,
  HIT_WLA_OC_UPDATE,
  HIT_WLA_ORG_PROCESS,
  HIT_WLA_PROGRESS_SUMMARY,
  HIT_WLA_STATUS,
  HIT_WLA_SUBMIT_TEMPLATE,
  HIT_WORKER_TYPE_CREATE,
  HIT_WORKER_TYPE_LIST,
  HIT_WORKER_TYPE_UPDATE,
} from 'redux/actions/wla';
import {
  apiBOActivityType,
  apiBoAPQC,
  apiBoAPQCCreate,
  apiBoAPQCImport,
  apiBoAPQCList,
  apiBoAPQCMove,
  apiBoAPQCUpdate,
  apiBoAPQCUpdateLibrary,
  apiBOCategoryGroup,
  apiBOClassification,
  apiBoCompanyDelete,
  apiBoCompanyList,
  apiBOCompDetail,
  apiBOCompLibrary,
  apiBOCreateStructure,
  apiBoDashboard,
  apiBODetailStructure,
  apiBODirectorate,
  apiBOFTE,
  apiBOImportAddOrganization,
  apiBOImportBoardEmployee,
  apiBOImportBoardStructure,
  apiBOImportUpdateEmployee,
  apiBOImportUpdateStructure,
  apiBOJobLevel,
  apiBOLevelDesc,
  apiBOListEmployee,
  apiBOListProcess,
  apiBOListStructure,
  apiBoLogList,
  apiBoLogListFeature,
  apiBOMember,
  apiBOOrgParameter,
  apiBORegion,
  apiBOReportTo,
  apiBOSkillGroup,
  apiBoSubscripitonCreate,
  apiBoSubscripitonUpdate,
  apiBoSubscriptionList,
  apiBOSubSkillGroup,
  apiBOUpdateBoard,
  apiBOUpdateEmployee,
  apiBOUpdateStructure,
  apiBoUserCreate,
  apiBoUserList,
  apiBoUserUpdate,
  apiBOWorkerType,
  apiCompetencyCreate,
  apiCompetencyList,
  apiCompetencyUpdate,
  apiFeatureList,
  apiListBoardCompany,
  apiWorkloadList,
} from 'redux/api/backOffice';
import {
  apiAddApqc,
  apiAddTree,
  apiApqcLib,
  apiApqcTemplate,
  apiApqcVer,
  apiCreateBS,
  apiCreateChildTree,
  apiCreateCopyBS,
  apiDeleteProcess,
  apiDetailBS,
  apiHierarchy,
  apiImportProcess,
  apiImportProcessCopy,
  apiIndexViewBS,
  apiListProcessLevel,
  apiMoveTree,
  apiTreeView,
  apiUpdateBS,
} from 'redux/api/business_process';
import {
  apiCompetencyDelete,
  apiCompetencyInquiry,
  apiCompetencyLibCreate,
  apiCompetencyLibUpdate,
  apiCompetencyMove,
  apiCopCreate,
  apiCopList,
  apiCopUpdate,
  apiCreateLevelDesc,
  apiCustomManagement,
  apiCustomManagementCreate,
  apiCustomManagementUpdate,
  apiDetailCompany,
  apiDetailCompetency,
  apiImportCompetencyLib,
  apiInviteCompanyMember,
  apiListCompanyMember,
  apiListLevelDesc,
  apiMoveOrderActivity,
  apiMoveOrderFteLimit,
  apiSkillGroupAdd,
  apiSkillGroupList,
  apiSubSkillGroupList,
  apiUpdateCompany,
  apiUpdateLevelDesc,
} from 'redux/api/company';
import { apiListLvl1 } from 'redux/api/cvc';
import { apiDashboardCompany, apiGetDashboard } from 'redux/api/dashboard';
import {
  apiAuthorityJobDesc,
  apiDetailJobDescV2,
  apiKPIJobdesc,
  apiMainRespoJobDesc,
  apiOrgStructureJobDesc,
  apiWorkingRelationShipJobDesc,
  getListJobDesc,
  getListVersionID,
  getShowJobDescDetail,
  postHrApprove,
} from 'redux/api/jobdesc';
import {
  getChangeMatrix,
  getListConflict,
  getListPeriodMatrix,
  getMergeMatrix,
  getPivotList,
  getStructureStat,
  getViewDetailProcess,
  getViewMatrix,
  getViewMatrixProcessV2,
  getViewMatrixRevamp,
  getViewMatrixStructureV2,
  postClosedStat,
  postCreateMatrix,
  postImportMatrix,
} from 'redux/api/matrix';
import {
  apiAddEmployee,
  apiBankList,
  apiCreateDirectore,
  apiCreateEmployeeCopyBoard,
  apiCreateJobLvl,
  apiCreateNodeEmployee,
  apiCreateNodeStructure,
  apiCreateStructure,
  apiCreateStructureCopyBoard,
  apiDeleteDirectorate,
  apiDetailStructure,
  apiEditEmployee,
  apiEmployee,
  apiEmployeeViewStructure,
  apiFocusPositionEmployee,
  apiFocusPositionStructure,
  apiImportEmployeeUpdate,
  apiImportProcessOrg,
  apiImportStructureUpdate,
  apiJobLvl,
  apiListDirectorate,
  apiListDivision,
  apiOrganization,
  apiOrganizationNoLimit,
  apiUpdateDirectore,
  apiUpdateJobLvl,
  apiUpdateNodeEmployee,
  apiUpdateStructure,
  apiViewStructure,
} from 'redux/api/organization';
import { apiGetProfile } from 'redux/api/profile';
import {
  apiGetValidationCompany,
  apiGetValidationDashboard,
  apiGetValidationMatrix,
} from 'redux/api/validationRole';
import {
  apiBarChart,
  apiBoardOtherCategory,
  apiCreateActivityType,
  apiCreateLimitFTE,
  apiCreateOtherCategory,
  apiCreateRegion,
  apiDetailChart,
  apiExportDataActivity,
  apiExportDataOverall,
  apiListActivityType,
  apiListEmployeeRegion,
  apiListLimitFTE,
  apiListLimitFTEPublic,
  apiListOtherCategory,
  apiListOtherCategoryDepartment,
  apiListOtherCategoryEmployee,
  apiListOtherCategoryOrg,
  apiListOtherCategoryPublic,
  apiListRegion,
  apiListWlaTemplate,
  apiOnSaveWLA,
  apiPostAssessmentWLA,
  apiPostWlaTemplate,
  apiStructureEmployee,
  apiUpdateActivityType,
  apiUpdateLimitFTE,
  apiUpdateOtherCategory,
  apiUpdateRegion,
  apiValidationWLA,
  apiWlaCreate,
  apiWlaDashboardDivision,
  apiWlaDashboardEmployee,
  apiWlaDashboardJobLvl,
  apiWlaDashboardOrg,
  apiWlaDetailStatus,
  apiWlaList,
  apiWlaListStatus,
  apiWlaProcessChart,
  apiWlaProcessDetail,
  apiWlaProcessList,
  apiWlaProgressSummary,
  apiWlaStatus,
  apiWlaUpdate,
} from 'redux/api/wla';

// REVAMP
import {
  apiActionplanList,
  apiActionplanListDepartment,
  apiActionplanListTeam,
} from '_revamp/redux/api/admin/action_plan';
import {
  apiDepartmentDashboard,
  apiOkrDashboard,
  apiTeamDashboard,
} from '_revamp/redux/api/admin/dashboard/admin';
import {
  apiInitiativeDetail,
  apiInitiativeList,
  apiInitiativeListDepartment,
  apiInitiativeListTeam,
} from '_revamp/redux/api/admin/initiative';
import {
  apiAddOkr,
  apiAllList,
  apiAssignment,
  apiDelAssignment,
  apiDeleteOkr,
  apiDetailOkr,
  apiDuplicateOkr,
  apiEditOkr,
  apiKeyresultList,
  apiListMeasurenment,
  apiListProcess,
  apiOkrList,
  apiOkrListDepartmen,
  apiOkrListTeam,
  apiOkrStatus,
  apiPtComment,
  apiPtHierarchy,
  apiUpdateProgress,
} from '_revamp/redux/api/admin/okr';
import { apiLoginAdminV2, apiLoginEmployeeV2 } from '_revamp/redux/api/auth';

import {
  GET_ACTIONPLAN_LIST,
  HIT_ACTIONPLAN_LIST,
} from '_revamp/redux/action/admin/action_plan';
import {
  GET_DEPARTMENT_DASHBOARD,
  GET_OKR_DASHBOARD,
  GET_TEAM_DASHBOARD,
  HIT_DEPARTMENT_DASHBOARD,
  HIT_OKR_DASHBOARD,
  HIT_TEAM_DASHBOARD,
} from '_revamp/redux/action/admin/dashboard/admin';
import {
  GET_PT_DEPARTEMENT,
  HIT_PT_ADD_DEPARTEMENT,
  HIT_PT_ADD_DEPARTMENT_MEMBER,
  HIT_PT_DELETE_DEPARTEMENT,
  HIT_PT_DEPARTEMENT,
  HIT_PT_UPDATE_DEPARTEMENT,
} from '_revamp/redux/action/admin/departement';
import {
  GET_PT_LIST_BOARD,
  GET_PT_LIST_EMPLOYEE,
  GET_PT_LIST_EMPLOYEE_MANAGMENT,
  GET_PT_LIST_JOB_LEVEL,
  GET_PT_LIST_STRUCTURE,
  HIT_PT_ADD_EMPLOYEE,
  HIT_PT_LIST_BOARD,
  HIT_PT_LIST_EMPLOYEE,
  HIT_PT_LIST_EMPLOYEE_MANAGEMENT,
  HIT_PT_LIST_JOB_LEVEL,
  HIT_PT_LIST_STRUCTURE,
} from '_revamp/redux/action/admin/employee/admin';
import {
  GET_INITIATIVE_DETAIL,
  GET_INITIATIVE_LIST,
  HIT_INITIATIVE_DETAIL,
  HIT_INITIATIVE_LIST,
} from '_revamp/redux/action/admin/intiative';
import {
  GET_LIST_MEASURENMENT,
  GET_LIST_PROCESS,
  GET_OKR_DETAIL,
  GET_OKR_LIST,
  GET_OKR_RESPONSE,
  GET_OKR_STATUS,
  GET_PT_HIERARCHY,
  GET_PT_INITIATIVE_LIST,
  GET_PT_KEYRESULT_LIST,
  GET_PT_OBJECTIVE_LIST,
  GET_TEMPORARY_ASSIGNMENT,
  HIT_ADD_ASSIGNMENT,
  HIT_ADD_OKR,
  HIT_EDIT_OKR,
  HIT_LIST_MEASURENMENT,
  HIT_LIST_PROCESS,
  HIT_OKR_DETAIL,
  HIT_OKR_LIST,
  HIT_OKR_STATUS,
  HIT_PT_COMMENT,
  HIT_PT_DEL_ASSIGNMENT,
  HIT_PT_HIERARCHY,
  HIT_PT_INITIATIVE_LIST,
  HIT_PT_KEYRESULT_LIST,
  HIT_PT_OBJECTIVE_LIST,
  HIT_PT_OKR_DELETE,
  HIT_PT_OKR_DUPLICATE,
  HIT_TEMPORARY_ASSIGNMENT,
  HIT_UPDATE_PROGRESS,
} from '_revamp/redux/action/admin/okr';
import {
  GET_PT_TEAM_MANAGEMENT,
  HIT_PT_ADD_TEAM_MANAGEMENT,
  HIT_PT_ADD_TEAM_MEMBER,
  HIT_PT_TEAM_MANAGEMENT,
} from '_revamp/redux/action/admin/team_management';
import { GET_LOGINV2, HIT_LOGINV2 } from '_revamp/redux/action/auth';
import {
  apiPtAddDepartment,
  apiPtAddDepartmentMember,
  apiPtDeleteDepartment,
  apiPtListDepartment,
  apiPtUpdateDepartment,
} from '_revamp/redux/api/admin/departemnet';
import {
  apiPtCreateEmployee,
  apiPtListAllEmployee,
  apiPtListBoard,
  apiPtListEmployeeManagement,
  apiPtListJobLevel,
  apiPtListStructure,
} from '_revamp/redux/api/admin/employee/admin';
import {
  apiPtAddTeamManagement,
  apiPtAddTeamMember,
  apiPtListTeamManagement,
} from '_revamp/redux/api/admin/team_management';

import useTransformLoader from 'components/transformLoader';

const random = () => Math.random()?.toString(36).slice(-5);
const { tf } = useTransformLoader();

// AUTH   ✅
function* getLogin({ payload }) {
  const { data, history } = payload;
  try {
    yield put({
      type: DO_LOADING,
      payload: true,
    });
    yield put({
      type: DO_SWITCH_ON,
      payload: 'dashboardUp',
    });
    yield put({
      type: DO_SWITCH_ON,
      payload: 'dashboardList',
    });
    const login = yield call(apiLogin, data);
    yield put({
      type: GET_LOGIN,
      payload: login.data,
    });
    if (login && data.user_level === '1') {
      history.push('/board');
    }
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: login.message,
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: HIT_BOARD_STATUS, payload: 'failed' });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* postForgotPass({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const login = yield call(apiForgotPass, payload.data);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: login.message,
      },
    });
    payload.callback();
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: HIT_BOARD_STATUS, payload: 'failed' });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
// BOARD ***** BOARD   ✅
function* getListBoard({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('board').dashboardList,
    });
    const board = yield call(apiListBoard, payload);

    yield put({ type: GET_LIST_BOARD, payload: board });
    yield put({ type: DO_SWITCH_OFF, payload: tf('board').dashboardList });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('board').dashboardList });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* getListMemberBoard({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('board').memberBoard,
    });
    const board = yield call(apiListMemberBoard, payload);

    yield put({ type: GET_LIST_MEMBER_BOARD, payload: board });
    yield put({ type: DO_SWITCH_OFF, payload: tf('board').memberBoard });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('board').memberBoard });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* deleteBoard({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const board = yield call(apiDeleteBoard, payload);
    yield put({
      type: HIT_LIST_BOARD,
      payload: {
        member_id: localStorage.getItem('member_id'),
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: board.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* createBoard({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const board = yield call(apiCreateBoard, payload);
    yield put({
      type: HIT_LIST_BOARD,
      payload: {
        member_id: localStorage.getItem('member_id'),
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: board.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* updateBoard({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const board = yield call(apiUpdateBoard, payload);
    yield put({
      type: HIT_LIST_BOARD,
      payload: {
        member_id: localStorage.getItem('member_id'),
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: board.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* duplicateBoard({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const board = yield call(apiDuplicateBoard, payload);
    yield put({
      type: HIT_LIST_BOARD,
      payload: {
        member_id: localStorage.getItem('member_id'),
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: board.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* inviteBoard({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const board = yield call(apiInviteBoard, payload);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: board.message,
      },
    });
    yield put({
      type: HIT_LIST_MEMBER_BOARD,
      payload: {
        board_id: localStorage.getItem('board_id'),
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: HIT_BOARD_STATUS, payload: 'failed' });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* dashboardCompany({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('board').dashboardUp,
    });
    const board = yield call(apiDashboardCompany, payload);
    yield put({ type: GET_DASHBOARD_COUNT, payload: board.data });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('board').dashboardUp,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

// COMPANY ***** COMPANY   ✅

function* inviteCompanyMember({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const invite = yield call(apiInviteCompanyMember, payload);
    yield put({
      type: HIT_LIST_MEMBER,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: invite.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: HIT_BOARD_STATUS, payload: 'failed' });

    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* registerCompanyMember({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const register = yield call(apiRegisterCompanyMember, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: register.message,
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* registerCompany({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    // yield call(apiRegisterCompany, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    if (payload.type === 'failed') {
      yield put({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'failed',
          message: payload.msg || 'Register Company is failed!',
        },
      });
    }
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* listCop({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('company').companyCustomOrganization,
    });
    const data = yield call(apiCopList, payload);
    yield put({
      type: GET_COP_LIST,
      payload: data,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyCustomOrganization,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyCustomOrganization,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* createCop({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiCopCreate, payload);
    yield put({
      type: HIT_COP_LIST,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Data berhasil di simpan',
      },
    });
    // yield put({
    //   type: GET_COP_LIST,
    //   payload: {
    //     data: data,
    //     insertData: true
    //   }
    // });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* updateCop({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });

    const data = yield call(apiCopUpdate, payload.data);

    yield put({
      type: HIT_COP_LIST,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'perubahan data berhasil disimpan',
      },
    });
    // yield put({
    //   type: GET_COP_LIST,
    //   payload: {
    //     data: data,
    //     status: payload.data.status,
    //     updateData: true,
    //     id: payload.id,
    //     cust_id: payload.data.company_cust_param_id
    //   }
    // });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* listCustomManagement({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('company').companyCategoryGroup,
    });

    const data = yield call(apiCustomManagement);
    yield put({
      type: GET_CUSTOM_MANAGEMENT,
      payload: {
        data,
      },
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyCategoryGroup,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyCategoryGroup,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* createCustomManagement({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiCustomManagementCreate, payload.data);
    yield put({
      type: HIT_CUSTOM_MANAGEMENT,
    });
    // yield put({
    //   type: GET_CUSTOM_MANAGEMENT,
    //   payload: {
    //     updateData: false,
    //     data: data
    //   }
    // });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* updateCustomManagement({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiCustomManagementUpdate, payload.data);
    yield put({
      type: HIT_CUSTOM_MANAGEMENT,
    });

    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* listCompetencyLib({ payload }) {
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('company').companyLibray });
    const data = yield call(apiCompetencyList, payload);
    yield put({
      type: GET_COMPETENCY_LIB,
      payload: {
        data,
      },
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').companyLibray });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_COMPETENCY_LIB,
      payload: 'RESET',
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').companyLibray });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* createCompetencyLib({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiCompetencyLibCreate, payload.data);
    const getList = yield call(apiCompetencyList, {
      company_id: payload.data.company_id,
      type: payload.data.type,
      status: 'active',
    });
    yield put({
      type: GET_COMPETENCY_LIB,
      payload: {
        data: getList,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* updateCompetencyLib({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiCompetencyLibUpdate, payload.data);
    const getList = yield call(apiCompetencyList, {
      company_id: payload.data.company_id,
      type: payload.data.type,
      status: 'active',
    });
    yield put({
      type: GET_COMPETENCY_LIB,
      payload: {
        data: getList,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* importCompetency({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiImportCompetencyLib, payload);
    const getList = yield call(apiCompetencyList, {
      company_id: payload.company_id,
      type: payload.competencies[0].type,
      status: 'active',
    });
    yield put({
      type: GET_COMPETENCY_LIB,
      payload: {
        data: getList,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* inquiryCompetency({ payload }) {
  const { competency_id, setShowInquiryComp } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    setShowInquiryComp(true);
    const datas = yield call(apiCompetencyInquiry, { competency_id });
    yield put({
      type: GET_COMPETENCY_INQUIRY,
      payload: {
        datas,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_COMPETENCY_INQUIRY,
      payload: [],
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* deleteCompetency({ payload }) {
  const { datas, competency_id } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiCompetencyDelete, { competency_id });
    yield put({
      type: HIT_COMPETENCY_LIB,
      payload: {
        company_id: datas.company_id,
        type: datas.type,
        status: datas.status,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'berhasil dihapus',
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* getListDetailCompetency({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('company').companyCompetencyDetail,
    });
    const data = yield call(apiDetailCompetency, payload);
    yield put({
      type: GET_DETAIL_COMPETENCY,
      payload: {
        data,
      },
    });

    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyCompetencyDetail,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyCompetencyDetail,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_DETAIL_COMPETENCY,
      payload: {
        data: [],
      },
    });
  }
}
function* getListLevelDesc({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('company').companyLevelDescription,
    });
    const data = yield call(apiListLevelDesc, payload);
    yield put({
      type: GET_LIST_LEVEL_DESCRIPTION,
      payload: {
        data,
      },
    });

    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyLevelDescription,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyLevelDescription,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* createLevelDesc({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiCreateLevelDesc, payload.data);
    yield put({
      type: HIT_LIST_LEVEL_DESCRIPTION,
      payload: {
        company_id: localStorage.getItem('company_id'),
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* updateLevelDesc({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiUpdateLevelDesc, payload.data);
    yield put({
      type: HIT_LIST_LEVEL_DESCRIPTION,
      payload: {
        company_id: localStorage.getItem('company_id'),
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* activityMoveOrder({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiMoveOrderActivity, payload.data);
    yield put({
      type: HIT_ACTIVITY_TYPE_LIST,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* fteLimitMoveOrder({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiMoveOrderFteLimit, payload.data);
    yield put({
      type: HIT_LIST_LIMIT_FTE,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* listCompanyMemebr({ payload }) {
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('company').memberCompany });
    const data = yield call(apiListCompanyMember, payload);
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').memberCompany });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_LIST_MEMBER,
      payload: data,
    });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').memberCompany });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* detailCompany({ payload }) {
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('company').detailCompany });
    const data = yield call(apiDetailCompany, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_DETAIL_COMPANY,
      payload: data,
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* updateCompany({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiUpdateCompany, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* listSkillGroup() {
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('company').list_skill_group });
    const data = yield call(apiSkillGroupList);
    yield put({
      type: GET_LIST_SKILL_GROUP,
      payload: data,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').list_skill_group });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').list_skill_group });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* listSubSkillGroup({ payload, isMultipleSubSkillGroup, index }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('company').list_sub_skill_group,
    });
    if (!isMultipleSubSkillGroup && index === undefined) {
      const data = yield call(apiSubSkillGroupList, payload);
      yield put({
        type: GET_LIST_SUB_SKILL_GROUP,
        payload: data,
      });
    } else if (!isMultipleSubSkillGroup && index !== undefined) {
      yield put({
        type: DO_SWITCH_ON,
        payload: tf('company').list_multiple_sub_skill_group,
      });
      const data = yield call(apiSubSkillGroupList, payload);
      const result = data.data
        ?.filter((val) => val.status === 'active')
        .map((item) => ({
          value: item.competency_sub_skill_group_id,
          label: item.sub_skill_group_name,
        }));
      yield put({
        type: GET_UPDATE_SUB_SKILL_GROUP_MULTIPLE,
        payload: {
          index,
          list: result,
        },
      });
    } else if (isMultipleSubSkillGroup && index === undefined) {
      const result = yield all(
        payload.map((item) => call(apiSubSkillGroupList, item)),
      );
      const dataMultiple = result.map((res) => res.data
        ?.filter((data) => data.status === 'active')
        .map((val) => ({
          value: val.competency_sub_skill_group_id,
          label: val.sub_skill_group_name,
        })));
      yield put({
        type: GET_LIST_SUB_SKILL_GROUP_MULTIPLE,
        payload: dataMultiple,
      });
    }
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').list_sub_skill_group,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').list_multiple_sub_skill_group,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').list_sub_skill_group,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').list_multiple_sub_skill_group,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* addSkillGroup({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiSkillGroupAdd, payload);
    yield put({
      type: HIT_LIST_SKILL_GROUP,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

// BUSINESS PROCESS ***** BUSINESS PROCESS   ✅
function* getCvcLvl1({ payload }) {
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('bispro').listCVC });
    const lvl1 = yield call(apiListLvl1, payload);

    yield put({
      type: GET_CVC_LVL_1,
      payload: {
        data: lvl1,
        level: payload.level,
        idx: payload.parent_id,
      },
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('bispro').listCVC });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('bispro').listCVC });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_CVC_LVL_1,
      payload: {
        data: [],
        level: payload.level,
        idx: payload.parent_id,
      },
    });
  }
}
function* getListIndexView({ payload }) {
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('bispro').listIndexProcess });
    const index = yield call(apiIndexViewBS, payload);
    yield put({
      type: GET_INDEX_VIEW,
      payload: index,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('bispro').listIndexProcess });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('bispro').listIndexProcess });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: GET_INDEX_VIEW, payload: [] });
  }
}
function* getDetailBS({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiDetailBS, payload);
    yield put({
      type: GET_DETAIL_BS,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* createBS({ payload }) {
  const {
    body, dispatch, data_form, is_copy,
  } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    let index = '';
    if (is_copy) {
      index = yield call(apiCreateCopyBS, body);
    } else {
      index = yield call(apiCreateBS, body);
    }

    // yield put({
    //   type: HIT_BOARD_STATUS,
    //   payload: {
    //     status: "success",
    //     message: index.message
    //   }
    // });
    let catchError = false;
    data_form.map((v) => {
      if (v.standart_waktu.length <= 0 || v.activity_name.length <= 0) {
        catchError = true;
      }
    });

    if (data_form.length > 0 && index.data.process_id !== undefined) {
      dispatch({
        type: HIT_WLA_SUBMIT_TEMPLATE,
        payload: {
          process_id: index.data.process_id,
          data_form,
        },
      });
    }

    yield put({
      type: HIT_TREE_VIEW,
      payload: {
        board_id: localStorage.getItem('board_id'),
      },
    });
    yield put({
      type: HIT_CVC_LVL_1,
      payload: {
        board_id: localStorage.getItem('board_id'),
        level: '1',
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* createChildTree({ payload }) {
  const {
    body, dispatch, data_form, is_copy,
  } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiCreateChildTree, payload.data);

    if (data_form.length > 0 && index.data.process_id !== undefined) {
      dispatch({
        type: HIT_WLA_SUBMIT_TEMPLATE,
        payload: {
          process_id: index.data.process_id,
          data_form,
        },
      });
    }

    yield put({
      type: HIT_TREE_VIEW,
      payload: {
        board_id: payload.board_id,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitDeleteProcess({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiDeleteProcess, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* updateBS({ payload }) {
  const {
    data, dispatch, data_form, process_id,
  } = payload;

  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiUpdateBS, data);
    yield put({
      type: HIT_TREE_VIEW,
      payload: {
        board_id: payload.board_id,
      },
    });
    yield put({
      type: HIT_CVC_LVL_1,
      payload: {
        board_id: payload.board_id,
        level: '1',
      },
    });
    yield put({
      type: HIT_INDEX_VIEW,
      payload: {
        board_id: payload.board_id,
      },
    });
    // yield put({
    //   type: GET_INDEX_VIEW,
    //   payload: index,
    //   update: true
    // });

    yield put({
      type: HIT_WLA_SUBMIT_TEMPLATE,
      payload: {
        process_id,
        data_form,
      },
    });

    yield put({
      type: GET_WLA_LIST_TEMPLATE,
      payload: [
        {
          activity_name: '',
          standart_waktu: '',
        },
      ],
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitHierarchy({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiHierarchy, payload);
    yield put({
      type: GET_HIERARCHY,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitTreeView({ payload }) {
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('bispro').listTreeView });
    const index = yield call(apiTreeView, payload);
    yield put({
      type: GET_TREE_VIEW,
      payload: [...index],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('bispro').listTreeView });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('bispro').listTreeView });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: GET_TREE_VIEW, payload: [] });
  }
}
function* hitMoveTree({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiMoveTree, payload);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    const hitTreeView = yield call(apiTreeView, {
      board_id: localStorage.getItem('board_id'),
    });
    yield put({
      type: GET_TREE_VIEW,
      payload: [...hitTreeView],
    });
    yield put({
      type: HIT_CVC_LVL_1,
      payload: {
        board_id: localStorage.getItem('board_id'),
        level: '1',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitCreateTree({ payload }) {
  const { data_form } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiAddTree, payload.body);
    let catchError = false;
    data_form.map((v) => {
      if (v.standart_waktu.length <= 0 || v.activity_name.length <= 0) {
        catchError = true;
      }
    });

    if (data_form.length > 0 && index.data.new_process_id !== undefined) {
      yield put({
        type: HIT_WLA_SUBMIT_TEMPLATE,
        payload: {
          process_id: index.data.new_process_id,
          data_form,
        },
      });
    }

    yield put({
      type: HIT_TREE_VIEW,
      payload: {
        board_id: payload.board_id,
      },
    });
    yield put({
      type: HIT_CVC_LVL_1,
      payload: {
        board_id: payload.board_id,
        level: '1',
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitImportProcess({ payload }) {
  const { history, data, dispatch } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiImportProcess, data);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    dispatch({
      type: HIT_RESET,
      payload: 'business_process_index',
    });

    yield put({
      type: HIT_CVC_LVL_1,
      payload: {
        board_id: localStorage.getItem('board_id'),
        level: '1',
      },
    });
    yield put({
      type: HIT_TREE_VIEW,
      payload: {
        board_id: localStorage.getItem('board_id'),
      },
    });
    // history.push("/business-process/indexview");
  } catch (error) {
    const dataError = error.raw.data;
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        tempData: dataError,
        message: 'importBp',
        button: 're-upload-matrix',
        listView: Object.keys(dataError).length !== 0 ? 'listView' : '',
      },
    });
  }
}
function* hitImportProcessCopy({ payload }) {
  const { history, data, dispatch } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiImportProcessCopy, data);
    dispatch({
      type: HIT_RESET,
      payload: 'business_process_index',
    });
    if (payload.state !== 'treeView') {
      yield put({
        type: HIT_INDEX_VIEW,
        payload: {
          board_id: localStorage.getItem('board_id'),
        },
      });
    } else {
      yield put({
        type: HIT_TREE_VIEW,
        payload: {
          board_id: localStorage.getItem('board_id'),
        },
      });
    }
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    // history.push("/business-process/indexview");
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* hitProcessLevel({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('bispro').listProcessLevel });
  try {
    const datas = yield call(apiListProcessLevel, payload);
    yield put({
      type: GET_LIST_PROCESS_LEVEL,
      payload: datas,
    });

    yield put({ type: DO_SWITCH_OFF, payload: tf('bispro').listProcessLevel });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('bispro').listProcessLevel });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({
      type: GET_LIST_PROCESS_LEVEL,
      payload: [],
    });
  }
}

// hit dashboard
function* hitDashboard({ payload }) {
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('dashboard').mainDashboard });
    const index = yield call(apiGetDashboard, payload);
    yield put({
      type: GET_DASHBOARD,
      payload: index,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('dashboard').mainDashboard });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_DASHBOARD,
      payload: false,
    });
  }
}
function* hitApqcVer__({ payload }) {
  try {
    // yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiApqcVer, payload);
    yield put({
      type: GET_APQC_VER,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitApqcLib__({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiApqcLib, payload);
    yield put({
      type: GET_APQC_LIB,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitApqcTemplate__({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiApqcTemplate, payload);
    yield put({
      type: GET_APQC_TEMPLATE,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitApqcCreate({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiAddApqc, payload);

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Adding new apqc is successfully!',
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
// organization

function* hitListRegion({ payload, loading = true }) {
  if (loading) {
    yield put({ type: DO_SWITCH_ON, payload: tf('company').companyRegion });
  }
  try {
    const index = yield call(apiListRegion, payload);
    yield put({
      type: GET_REGION_LIST,
      payload: index,
    });
    if (loading) {
      yield put({ type: DO_SWITCH_OFF, payload: tf('company').companyRegion });
      yield put({ type: DO_TRIGGER, payload: random() });
    }
  } catch (error) {
    if (loading) {
      yield put({ type: DO_SWITCH_OFF, payload: tf('company').companyRegion });
      yield put({ type: DO_TRIGGER, payload: random() });
    }
  }
}
function* hitCreateRegion({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiCreateRegion, payload);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Data berhasil di simpan',
      },
    });
    yield put({
      type: GET_REGION_LIST,
      payload: {
        data: index,
        insert_data: true,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitUpdateRegion({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiUpdateRegion, payload.data);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Perubahan data berhasil di simpan',
      },
    });
    yield put({
      type: GET_REGION_LIST,
      payload: { data: index, update_data: true, id: payload.id },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitEmployee({ payload }) {
  if (payload.limit !== undefined && payload.offset !== undefined) {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('organization').listEmployeeLimit,
    });
  } else {
    yield put({ type: DO_SWITCH_ON, payload: tf('organization').listEmployee });
  }
  try {
    const index = yield call(apiEmployee, payload);
    if (payload.limit !== undefined && payload.offset !== undefined) {
      yield put({
        type: GET_LIST_EMPLOYEE_LIMIT,
        payload: index,
      });
    } else {
      yield put({
        type: GET_LIST_EMPLOYEE,
        payload: index,
      });
    }
    if (payload.limit !== undefined && payload.offset !== undefined) {
      yield put({
        type: DO_SWITCH_OFF,
        payload: tf('organization').listEmployeeLimit,
      });
    } else {
      yield put({
        type: DO_SWITCH_OFF,
        payload: tf('organization').listEmployee,
      });
    }
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').listEmployee,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').listEmployeeLimit,
    });
    if (!payload.limit && !payload.offset) {
      yield put({
        type: GET_LIST_EMPLOYEE,
        payload: [],
      });
    } else {
      yield put({
        type: GET_LIST_EMPLOYEE_LIMIT,
        payload: [],
      });
    }
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitAddEmployee({ payload }) {
  const { limit, offset } = yield select(
    (state) => state.organization.paginationEmployee,
  );
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiAddEmployee, payload.data);
    yield put({
      type: HIT_LIST_EMPLOYEE,
      payload: {
        board_id: payload.board_id,
        limit,
        offset,
      },
    });
    yield put({
      type: HIT_EMPLOYEE_CHART,
      payload: {
        board_id: payload.board_id,
      },
    });
    yield put({
      type: HIT_LIST_EMPLOYEE,
      payload: {
        board_id: payload.board_id,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: true });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitCreateEmployee({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  if (payload.status !== 'failed' && payload.status !== undefined) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: payload.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } else {
    yield put({ type: DO_LOADING, payload: true });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: payload.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitUpdateEmployee({ payload }) {
  const { limit, offset } = yield select((state) => state.organization.paginationEmployee);
  const boardId = localStorage.getItem('board_id');
  try {
    yield put({ type: DO_LOADING, payload: true });
    if (payload.status === 'failed') {
      yield put({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'failed',
          message: payload.message,
        },
      });
    } else {
      yield put({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'success',
          message: payload.message,
        },
      });
    }
    yield put({
      type: HIT_LIST_EMPLOYEE,
      payload: {
        board_id: boardId,
        limit,
        offset,
      },
    });
    yield put({
      type: HIT_EMPLOYEE_CHART,
      payload: {
        board_id: boardId,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* hitEditEmployee({ payload }) {
  const { limit, offset } = yield select(
    (state) => state.organization.paginationEmployee,
  );
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiEditEmployee, payload.data);
    yield put({
      type: HIT_LIST_EMPLOYEE,
      payload: {
        board_id: payload.board_id,
        limit,
        offset,
      },
    });
    yield put({
      type: HIT_EMPLOYEE_CHART,
      payload: {
        board_id: payload.board_id,
      },
    });
    yield put({
      type: HIT_LIST_EMPLOYEE,
      payload: {
        board_id: payload.board_id,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: true });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitCreateEmployeeNode({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiCreateNodeEmployee, payload.datas);
    yield put({
      type: HIT_LIST_EMPLOYEE,
      payload: {
        board_id: payload.board_id,
      },
    });
    yield put({
      type: HIT_EMPLOYEE_CHART,
      payload: {
        board_id: payload.board_id,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitUpdateEmployeeNode({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiUpdateNodeEmployee, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitOrganization({ payload }) {
  if (!payload.limit && !payload.offset) {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('organization').listStructure,
    });
  } else {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('organization').listStructureLimit,
    });
  }
  try {
    if (
      payload.limit !== undefined
      && payload.offset !== undefined
      && payload.type !== 'report-to'
    ) {
      const index = yield call(apiOrganization, payload);
      yield put({
        type: GET_LIST_ORGANIZATION_LIMIT,
        payload: index,
      });
    } else {
      const index = yield call(apiOrganizationNoLimit, payload);
      yield put({
        type: GET_LIST_ORGANIZATION,
        payload: {
          data: index,
        },
      });
    }
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').listStructure,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').listStructureLimit,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    // return index;
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').listStructure,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').listStructureLimit,
    });
    if (!payload.limit && !payload.offset) {
      yield put({
        type: GET_LIST_ORGANIZATION,
        payload: [],
      });
    } else {
      yield put({
        type: GET_LIST_ORGANIZATION_LIMIT,
        payload: [],
      });
    }
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitListJob({ payload }) {
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('board').jobLevel });
    const index = yield call(apiJobLvl, payload);
    yield put({
      type: GET_LIST_JOB,
      payload: index,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('board').jobLevel });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_LIST_JOB,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('board').jobLevel });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitCreateJobLvl({ payload }) {
  const { data } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiCreateJobLvl, data);
    yield put({
      type: HIT_LIST_JOB,
      payload: {
        board_id: localStorage.getItem('board_id'),
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitUpdateJobLvl({ payload }) {
  const { data } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiUpdateJobLvl, data);
    yield put({
      type: HIT_LIST_JOB,
      payload: {
        board_id: localStorage.getItem('board_id'),
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitViewStructure({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('organization').chartStructure,
    });
    const index = yield call(apiViewStructure, payload);
    yield put({
      type: GET_STRUCTURE,
      payload: index,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').chartStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').chartStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: GET_STRUCTURE, payload: [] });
  }
}
function* hitViewDetailStructure({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('organization').detailStructure,
    });
    const index = yield call(apiDetailStructure, payload);
    yield put({
      type: GET_DETAIL_STRUCTURE,
      payload: index,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').detailStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').detailStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitCreateStructure({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiCreateStructure, payload.data);
    if (payload.isStructure) {
      yield put({
        type: HIT_STRUCTURE,
        payload: {
          board_id: localStorage.getItem('board_id'),
        },
      });
    }
    yield put({
      type: HIT_LIST_ORGANIZATION,
      payload: {
        board_id: localStorage.getItem('board_id'),
        limit: 10,
        offset: 0,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitCreateNodeStructure({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiCreateNodeStructure, payload.data);
    const temp = {
      board_id: localStorage.getItem('board_id'),
      limit: 10,
      offset: 0,
    };
    if (payload.organization_id) temp.organization_id = payload.organization_id;
    // yield put({
    //   type: HIT_STRUCTURE,
    //   payload: temp
    // });
    yield put({
      type: HIT_LIST_ORGANIZATION,
      payload: temp,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitUpdateStructure({ payload }) {
  const { data, isFocusPosition, idFocus } = payload;
  const { limit, offset } = yield select(
    (state) => state.organization.paginationStructure,
  );
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiUpdateStructure, payload.data);
    if (payload.data.status === '0') {
      yield put({
        type: HIT_LIST_ORGANIZATION,
        payload: {
          board_id: localStorage.getItem('board_id'),
          limit,
          offset,
        },
      });
    } else {
      yield put({
        type: HIT_LIST_ORGANIZATION,
        payload: {
          board_id: localStorage.getItem('board_id'),
          limit,
          offset,
        },
      });
      // yield put({
      //   type: GET_LIST_ORGANIZATION,
      //   payload: index.data,
      //   update: true,
      // });
    }

    if (payload.board_id !== undefined && !isFocusPosition) {
      yield put({
        type: HIT_STRUCTURE,
        payload: { board_id: payload.board_id },
      });
    } else if (isFocusPosition) {
      yield put({
        type: HIT_FOCUS_POSITION,
        payload: {
          board_id: payload.board_id,
          organization_id: idFocus,
        },
      });
    }

    if (payload.isJobWizard) {
      payload.toast.success(index.message, { containerId: 'jobwizard' });
    } else {
      yield put({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'success',
          message: index.message,
        },
      });
    }

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });

    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitEmployeeChart({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('organization').chartEmployee,
    });
    const validation = yield call(apiGetValidationDashboard, payload);
    yield put({
      type: VALIDATION_ALL_STORE,
      payload: validation,
    });

    const index = yield call(apiEmployeeViewStructure, payload);
    yield put({
      type: GET_EMPLOYEE_CHART,
      payload: index,
    });

    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').chartEmployee,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('organization').chartEmployee,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: GET_EMPLOYEE_CHART, payload: [] });
  }
}
function* hitFocusPosition({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiFocusPositionStructure, payload);
    yield put({
      type: GET_FOCUS_POSITION,
      payload: index,
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitFocusPositionEmployee({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiFocusPositionEmployee, payload);
    yield put({
      type: GET_FOCUS_POSITION_EMPLOYEE,
      payload: index,
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBankList({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiBankList, payload);
    yield put({
      type: GET_BANK_LIST,
      payload: index,
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitCreateStructureCopy({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    let datas = '';
    if (payload.type === 2) {
      datas = yield call(apiCreateStructureCopyBoard, payload.data);
    } else if (payload.type === 1) {
      datas = yield call(apiCreateEmployeeCopyBoard, payload.data);
    }

    const board_id = localStorage.getItem('board_id');

    switch (payload.position) {
      case 'structure':
        yield put({
          type: HIT_STRUCTURE,
          payload: { board_id },
        });
        yield put({
          type: HIT_LIST_ORGANIZATION,
          payload: {
            board_id: localStorage.getItem('board_id'),
            limit: 10,
            offset: 0,
          },
        });
        break;
      case 'employee':
        yield put({
          type: HIT_LIST_EMPLOYEE,
          payload: { board_id },
        });
        yield put({
          type: HIT_EMPLOYEE_CHART,
          payload: { board_id },
        });
        break;

      default:
        yield put({
          type: HIT_LIST_ORGANIZATION,
          payload: {
            board_id: localStorage.getItem('board_id'),
            limit: 10,
            offset: 0,
          },
        });
        break;
    }

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: datas.message,
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitListDirectorate({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('company').companyDirectorate,
    });
    const result = yield call(apiListDirectorate);
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyDirectorate,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_LIST_DIRECTORATE,
      payload: result,
    });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyDirectorate,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitCreateDirectorate({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiCreateDirectore, payload);
    // yield put({
    //   type: GET_LIST_DIRECTORATE,
    //   payload: {
    //     data: {
    //       directorate_name: payload.directorate_name,
    //       directorate_id: payload.directorate_id,
    //     },
    //     insert_data: true
    //   }
    // });
    yield put({
      type: HIT_LIST_DIRECTORATE,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitUpdateDirectorate({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiUpdateDirectore, payload.data);
    yield put({
      type: GET_LIST_DIRECTORATE,
      payload: {
        data: {
          directorate_name: payload.data.directorate_name,
          directorate_id: payload.data.directorate_id,
        },
        id: payload.id,
        update_data: true,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* hitDeleteDirectorate({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const data = yield call(apiDeleteDirectorate, payload.data);
    yield put({ type: HIT_LIST_DIRECTORATE });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: data.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* hitListDivision({ payload }) {
  try {
    // yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiListDivision, payload);
    yield put({
      type: GET_LIST_DIVISION,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* hitImportProcessOrg({ payload }) {
  const { limit, offset } = yield select((state) => state.organization.paginationEmployee);
  try {
    const { onSuccess } = payload;
    yield put({ type: DO_LOADING, payload: true });
    let message = '';
    if (payload.type === 'add') {
      const index = yield call(apiImportProcessOrg, payload.data);
      message = index.message;
    } else if (payload.type === 'update_structure') {
      const index = yield call(apiImportStructureUpdate, payload.data);
      message = index.message;
    } else if (payload.type === 'update_employee') {
      const index = yield call(apiImportEmployeeUpdate, payload.data);
      message = index.message;
    }

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });

    if (payload.location !== 'employees') {
      yield put({
        type: HIT_LIST_ORGANIZATION,
        payload: {
          board_id: localStorage.getItem('board_id'),
          limit: 10,
          offset: 0,
        },
      });
      yield put({
        type: HIT_STRUCTURE,
        payload: {
          board_id: localStorage.getItem('board_id'),
        },
      });
    }

    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess();
    }

    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Data berhasil di simpan',
      },
    });
  } catch (error) {
    const dataError = error.raw.data;
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        tempData: dataError,
        message: error.message,
        listView: Object.keys(dataError).length !== 0 ? 'listView' : '',
      },
    });
  }
}
// SAGA MATRIX
function* hitViewMatrix({ payload }) {
  if (!payload?.organization_id) {
    yield put({
      type: GET_MATRIX_STATUS,
      payload: undefined,
    });
  } else {
    yield put({ type: DO_LOADING, payload: true });
  }

  try {
    const index = yield call(getViewMatrix, payload);

    if (payload.focus) {
      yield put({
        type: GET_VIEW_MATRIX_FOCUS,
        payload: index,
      });
    } else {
      yield put({
        type: GET_VIEW_MATRIX,
        payload: index,
      });
    }
    yield put({
      type: GET_MATRIX_STATUS,
      payload: true,
    });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: GET_MATRIX_STATUS,
      payload: false,
    });
  }
}
function* hitViewMatrixStructure({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('matrix').matrixViewStructure });
  try {
    const index = yield call(getViewMatrixStructureV2, payload);
    yield put({
      type: GET_MATRIX_VIEW_STRUCTURE,
      payload: {
        focus: !!payload.focus,
        data: index.data,
        isGetAllOrg: !!payload.organization_ids,
        report_to: payload?.report_to || false,
      },
    });

    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('matrix').matrixViewStructure,
    });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('matrix').matrixViewStructure,
    });
    yield put({
      type: GET_MATRIX_STATUS,
      payload: false,
    });
  }
}
function* hitSelectedMatrixFocus({ payload }) {
  try {
    yield put({
      type: GET_SELECTED_MATRIX_FOCUS,
      payload,
    });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: 'Error view Focus Job',
      },
    });
  }
}
function* hitViewMatrixProcess({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('matrix').matrixViewProcess });
  try {
    const index = yield call(getViewMatrixProcessV2, payload);
    if (payload.focus) {
      yield put({
        type: GET_VIEW_MATRIX_FOCUS,
        payload: {
          data: index,
          body: payload,
        },
      });
      if (payload.reset) {
        yield put({
          type: GET_SELECTED_MATRIX_FOCUS,
          payload: payload.organization_id,
        });
      }
    } else {
      yield put({
        type: GET_MATRIX_VIEW_PROCESS,
        payload: {
          data: index,
          body: { ...payload },
        },
      });
    }
    yield put({
      type: GET_MATRIX_ACTIVE_PERIOD,
      payload: payload.periode_matrix_id,
    });
    yield put({
      type: GET_MATRIX_STATUS,
      payload: true,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('matrix').matrixViewProcess });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_SWITCH_OFF, payload: tf('matrix').matrixViewProcess });
    yield put({
      type: GET_MATRIX_STATUS,
      payload: false,
    });
  }
}

function* hitViewDetailOfProcess({ payload }) {
  try {
    const index = yield call(getViewDetailProcess, payload.data);
    yield put({
      type: GET_VIEW_DETAIL_OF_PROCESS,
      payload: index,
    });
    payload.setItemProcess(index);
    payload.setSummaryProcess(true);
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
  }
}
function* hitViewMatrix_dnd({ payload }) {
  try {
    const index = yield call(getViewMatrixRevamp, payload);

    yield put({
      type: GET_NEW_VIEW_MATRIX,
      payload: index,
    });

    // yield delay(2000);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitImportMatrix({ payload }) {
  try {
    const index = yield call(postImportMatrix, payload.data);
    yield put({
      type: HIT_LIST_PERIOD,
      payload: {
        board_id: localStorage.getItem('board_id'),
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    // payload.history.push("/organizations/jobwizard?id=default&position=0");
  } catch (error) {
    const dataError = error.raw.data;
    payload.func();
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        tempData: dataError,
        message: error.raw.message,
        button: 're-upload-matrix',
        listView: Object.keys(dataError).length !== 0 ? 'listView' : '',
      },
    });
  }
}
function* hitListPeriodMatrix({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('matrix').matrixListPeriode });
  try {
    const index = yield call(getListPeriodMatrix, payload);
    yield put({
      type: GET_LIST_PERIOD,
      payload: index,
    });

    yield put({ type: DO_SWITCH_OFF, payload: tf('matrix').matrixListPeriode });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_LIST_PERIOD,
      payload: [],
    });

    yield put({
      type: GET_MATRIX_STATUS,
      payload: false,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('matrix').matrixListPeriode });
    yield put({ type: DO_SWITCH_OFF, payload: tf('matrix').matrixViewProcess });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('matrix').matrixViewStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitChangeMatrix({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(getChangeMatrix, payload.data);

    yield put({
      type: GET_VIEW_MATRIX,
      payload: {
        process_id: payload.data.process_id,
        value: payload.data.value,
        org_id: payload.data.organization_id,
        prevValue: payload.prevVal,
      },
    });

    yield put({
      type: GET_VIEW_MATRIX_FOCUS_CHANGE,
      payload: {
        process_id: payload.data.process_id,
        value: payload.data.value,
        org_id: payload.data.organization_id,
        prevValue: payload.prevVal,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });

    payload.toast('success', index.message);
    // payload.updateList(payload.newData);
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    payload.toast('failed', error.message);
  }
}
function* hitCreateMatrix({ payload }) {
  const { history, setStatus } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(postCreateMatrix, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });

    history.push(`/audit-matrix/${index.data.periode_matrix_id}`);
    setStatus(0);
    // setTimeout(() => {
    //   //
    //   window.location.href = `/audit-matrix/${index["periode_matrix_id"]}`;
    // }, 500);
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitStructureMatrix({ payload }) {
  yield put({
    type: GET_MATRIX_STRUCTURE_STATUS,
    payload: [],
  });
  try {
    const index = yield call(getStructureStat, payload);
    yield put({
      type: GET_MATRIX_STRUCTURE_STATUS,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitClosedMatrix({ payload }) {
  const {
    setStatus, board_id, periode_matrix_id, history,
  } = payload;
  try {
    const index = yield call(postClosedStat, { board_id, periode_matrix_id });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
        tempData: index.data.periode_matrix_id,
      },
    });
    setStatus(1);
    // setTimeout(() => {
    //   window.location.href = `/matrix`;
    // }, 500);
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitMergeMatrix({ payload }) {
  const {
    setStatus, history, board_id, periode_matrix_id,
  } = payload;
  try {
    const index = yield call(getMergeMatrix, { board_id, periode_matrix_id });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    history.push('/matrix');
    setStatus(2);

    // setTimeout(() => {
    //   window.location.href = "/matrix";
    // }, 500);
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitListMatrix({ payload }) {
  const { setStatus, history } = payload;
  try {
    const index = yield call(getListConflict, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_LIST_CONFLICT,
      payload: index,
    });
    history.push('/matrix');
    setStatus(2);
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitListPivot({ payload }) {
  // const { setStatus, history } = payload;
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('matrix').pivotTable });
    const index = yield call(getPivotList, payload);
    yield put({
      type: GET_PIVOT_DATA,
      payload: index,
    });
    // history.push("/matrix");
    // setStatus(2);
    yield put({ type: DO_SWITCH_OFF, payload: tf('matrix').pivotTable });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('matrix').pivotTable });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: GET_PIVOT_DATA, payload: [] });
  }
}

// JOBDESC
function* hitListJobDesc({ payload }) {
  const { setStatus, history } = payload;
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('jobDesc').listJobDesc });
    const validation = yield call(apiGetValidationDashboard, payload);
    yield put({
      type: VALIDATION_ALL_STORE,
      payload: validation,
    });

    const index = yield call(getListJobDesc, payload);
    if (payload.offset !== undefined && payload.limit !== undefined) {
      yield put({
        type: GET_LIST_JOBDESC_LIMIT,
        payload: index,
      });
    } else {
      yield put({
        type: GET_LIST_JOBDESC,
        payload: index.data,
      });
    }
    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').listJobDesc });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    if (payload.offset !== undefined && payload.limit !== undefined) {
      yield put({
        type: GET_LIST_JOBDESC_LIMIT,
        payload: {
          data: [],
        },
      });
    } else {
      yield put({
        type: GET_LIST_JOBDESC,
        payload: [],
      });
    }
    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').listJobDesc });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitListVersionID({ payload }) {
  const { setStatus, history } = payload;
  try {
    // yield put({ type: DO_LOADING, payload: true });
    const index = yield call(getListVersionID, payload);

    yield put({
      type: GET_LIST_VERSIONID,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });

    // setTimeout(() => {
    //   window.location.href = "/matrix";
    // }, 500);
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitDetailJobDesc({ payload }) {
  const { setStatus, history } = payload.data;
  try {
    if (payload.loading) {
      yield put({ type: DO_SWITCH_ON, payload: tf('jobDesc').detailJobDesc });
    }
    const index = yield call(getShowJobDescDetail, payload.data);
    yield put({
      type: GET_DETAIL_JOBDESC,
      payload: index,
    });
    if (payload.loading) {
      // alert("s");
      yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').detailJobDesc });
      yield put({ type: DO_TRIGGER, payload: random() });
    }
  } catch (error) {
    if (payload.loading) {
      yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').detailJobDesc });
      yield put({ type: DO_TRIGGER, payload: random() });
    }
  }
}
function* hitHRApproval({ payload }) {
  const { history, pathname, search } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(postHrApprove, payload);

    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitDetailJobDescV2({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('jobDesc').detailJobDescV2 });
  try {
    const index = yield call(apiDetailJobDescV2, payload.data);
    yield put({
      type: GET_DETAIL_JOBDESC_V2,
      payload: index,
    });

    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').detailJobDescV2 });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').detailJobDescV2 });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_DETAIL_JOBDESC_V2,
      payload: {
        data: [],
      },
    });
  }
}
function* hitJobDescOrgStructure({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('jobDesc').jobDescOrgStructure });
  try {
    const index = yield call(apiOrgStructureJobDesc, payload.data);
    yield put({
      type: GET_ORG_STRUCTURE_JOBDESC,
      payload: index,
    });

    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('jobDesc').jobDescOrgStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('jobDesc').jobDescOrgStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_ORG_STRUCTURE_JOBDESC,
      payload: {
        data: [],
      },
    });
  }
}
function* hitJobDescMainRespo({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('jobDesc').mainRespo });
  try {
    const index = yield call(apiMainRespoJobDesc, payload.data);
    yield put({
      type: GET_MAINRESPO_JOBDESC,
      payload: index,
    });

    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').mainRespo });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').mainRespo });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_MAINRESPO_JOBDESC,
      payload: {
        data: [],
      },
    });
  }
}
function* hitJobDescKPI({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('jobDesc').jobDescKPI });
  try {
    const index = yield call(apiKPIJobdesc, payload.data);
    yield put({
      type: GET_KPI_JOBDESC,
      payload: index,
    });

    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').jobDescKPI });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').jobDescKPI });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_KPI_JOBDESC,
      payload: {
        data: [],
      },
    });
  }
}
function* hitJobDescAuthority({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('jobDesc').jobDescAuthority });
  try {
    const index = yield call(apiAuthorityJobDesc, payload.data);
    yield put({
      type: GET_AUTHORITY_JOBDESC,
      payload: index,
    });

    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').jobDescAuthority });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('jobDesc').jobDescAuthority });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_AUTHORITY_JOBDESC,
      payload: {
        data: [],
      },
    });
  }
}
function* hitJobDescWorkRelation({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('jobDesc').jobDescWorkRelation });
  try {
    const index = yield call(apiWorkingRelationShipJobDesc, payload.data);
    yield put({
      type: GET_WORK_RELATION_JOBDESC,
      payload: index,
    });

    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('jobDesc').jobDescWorkRelation,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('jobDesc').jobDescWorkRelation,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_WORK_RELATION_JOBDESC,
      payload: {
        data: [],
      },
    });
  }
}
function* hitValidationDashboard({ payload }) {
  const { history, pathname, search } = payload;
  try {
    const index = yield call(apiGetValidationDashboard, payload);
    yield put({
      type: VALIDATION_ALL_STORE,
      payload: index,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: VALIDATION_ALL_STORE,
      payload: {
        type: 'dashboard',
        value: false,
      },
    });
  }
}
function* hitValidationCompany({ payload }) {
  // const { history, pathname, search } = payload;
  try {
    const index = yield call(apiGetValidationCompany, payload);
    yield put({
      type: VALIDATION_ALL_STORE,
      payload: index,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: VALIDATION_ALL_STORE,
      payload: {
        type: 'company',
        value: false,
      },
    });
  }
}
function* hitValidationMatrix({ payload }) {
  const { history, pathname, search } = payload;
  try {
    yield put({ type: DO_SWITCH_ON, payload: tf('matrix').matrixValidation });
    const index = yield call(apiGetValidationMatrix, payload);
    yield put({
      type: VALIDATION_ALL_STORE,
      payload: index,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('matrix').matrixValidation });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('matrix').matrixValidation });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: VALIDATION_ALL_STORE,
      payload: {
        type: 'matrix',
        value: false,
      },
    });
  }
}
function* hitProfile({ payload }) {
  // const { history, pathname, search } = payload;
  try {
    yield put({ type: DO_LOADING, payload: true });
    const index = yield call(apiGetProfile, payload);
    yield put({
      type: GET_PROFILE,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: VALIDATION_ALL_STORE,
      payload: {
        type: 'profile',
        value: false,
      },
    });
  }
}
function* hitUpdateProfile({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    yield put({
      type: HIT_DETAIL_COMPANY,
      payload: {
        company_id: localStorage.getItem('company_id'),
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    switch (payload.type) {
      case 'company':
        yield put({
          type: HIT_BOARD_STATUS,
          payload: {
            status: 'success',
            message: payload.message,
          },
        });
        break;
      default:
        yield put({
          type: HIT_BOARD_STATUS,
          payload: {
            status: 'success',
            message: payload.message,
          },
        });
        break;
    }
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    // switch (payload.type) {
    //   case "company":
    //     yield put({
    //       type: HIT_BOARD_STATUS,
    //       payload: {
    //         status: "failed",
    //         message: error.message
    //       }
    //     });
    //     break;
    //   default:
    //     yield put({
    //       type: HIT_BOARD_STATUS,
    //       payload: {
    //         status: "failed",
    //         message: error.message
    //       }
    //     });
    //     break;
    // }
  }
}
function* hitBoCompany({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoCompanyList, payload);
    yield put({
      type: GET_BACKOFFICE_LIST,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitBoListSubs({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoSubscriptionList, payload);
    yield put({
      type: GET_BO_SUBSCRIPTION_LIST,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitBoListUser({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoUserList, payload);
    yield put({
      type: GET_BO_USER_LIST,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitBoListLog({ payload }) {
  try {
    const index = yield call(apiBoLogList, payload);
    yield put({
      type: GET_BO_LOG_LIST,
      payload: index,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_LOG_LIST,
      payload: [],
    });
  }
}
function* hitBoListLogFeature({ payload, onlylist }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    if (onlylist) {
      const indexz = yield call(apiBoLogListFeature);
      yield put({
        type: GET_BO_LOG_LIST_FEATURE,
        payload: indexz,
      });
    }
    const index = yield call(apiBoLogList, payload);
    yield put({
      type: GET_BO_LOG_LIST,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitBoCompanyDelete({ payload }) {
  const { data, dispatch } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoCompanyDelete, data);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Delete company is successfully!',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    dispatch({
      type: HIT_BACKOFFICE_LIST,
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitBoSubsCreate({ payload }) {
  const { data, history } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoSubscripitonCreate, data);
    if (index) {
      history.push('/back-office/subscription');
    }
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Create subscription is successfully!',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    // dispatch({
    //   type: HIT_BACKOFFICE_LIST,
    // });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitBoSubsUpdate({ payload }) {
  const { data, history } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoSubscripitonUpdate, data);
    if (index) {
      history.push('/back-office/subscription');
    }
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Update subscription is successfully!',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    // dispatch({
    //   type: HIT_BACKOFFICE_LIST,
    // });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitBoUserCreate({ payload }) {
  const { data, history } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoUserCreate, data);
    if (index) {
      history.push('/back-office/user-management');
    }
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Create User is successfully!',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    // dispatch({
    //   type: HIT_BACKOFFICE_LIST,
    // });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitBoUserUpdate({ payload }) {
  const { data, history } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoUserUpdate, data);
    if (index) {
      history.push('/back-office/user-management');
    }
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Update User is successfully!',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    // dispatch({
    //   type: HIT_BACKOFFICE_LIST,
    // });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* hitBoAPQC({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoAPQCList, payload);
    yield put({
      type: GET_BO_APQC_LIB,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitBoAPQCView({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoAPQC, payload);
    yield put({
      type: GET_BO_APQC,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_BO_APQC,
      payload: [],
    });
  }
}
function* hitBoAPQCUpdate({ payload }) {
  const { history, body, id } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoAPQCUpdate, body);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Update APQC is successfully!',
      },
    });
    history.push(`/back-office/apqc?id=${id}`);
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    history.push(`/back-office/apqc?id=${id}`);
  }
}
function* hitBoAPQCUpdateLibrary({ payload }) {
  const { history, body, id } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoAPQCUpdateLibrary, body);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Update APQC is successfully!',
      },
    });
    history.push(`/back-office/apqc?id=${id}`);
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    history.push(`/back-office/apqc?id=${id}`);
  }
}
function* hitBoAPQCCreate({ payload }) {
  const { history, body, id } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoAPQCCreate, body);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Create APQC is successfully!',
      },
    });
    history.push(`/back-office/apqc?id=${id}`);
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    history.push(`/back-office/apqc?id=${id}`);
  }
}
function* hitBoAPQCMove({ payload }) {
  const { body, dispatch, id } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoAPQCMove, body);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    dispatch({
      type: HIT_BO_APQC,
      payload: {
        apqc_library_id: id,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Move APQC is successfully!',
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    // history.push(`/back-office/apqc?id=${id}`);
  }
}
function* hitBoAPQCImport({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoAPQCImport, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Import APQC is successfully!',
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    // history.push(`/back-office/apqc?id=${id}`);
  }
}
function* hitBoDashboard({ payload }) {
  const { data, dispatch } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiBoDashboard, data);
    yield put({
      type: GET_BO_DASHBOARD,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitBoFeatureList({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiFeatureList);
    yield put({
      type: GET_BO_FEATURE,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWorkloadList({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiWorkloadList);
    yield put({
      type: GET_WORKLOAD_LIST,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitCompetencyCreate({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiCompetencyCreate, payload.data);

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    payload.path && payload.route.push(payload.path);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Competency berhasil di tambahkan!',
        tempData: index.periode_matrix_id,
      },
    });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitCompetencyUpdate({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiCompetencyUpdate, payload.data);

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    payload.path && payload.route.push(payload.path);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Competency berhasil di perbaharui!',
      },
    });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitCompetencyList({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiCompetencyList, payload);
    yield put({
      type: GET_COMPETENCY,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_COMPETENCY,
      payload: [],
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* hitBoardCompany({ payload }) {
  yield put({
    type: DO_SWITCH_ON, payload: tf('backOffice').bo_list_board,
  });
  try {
    const values = yield call(apiListBoardCompany, payload);
    yield put({
      type: GET_BO_COMPANY_BOARD,
      payload: values,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: DO_SWITCH_OFF, payload: tf('backOffice').bo_list_board,
    });
  } catch (error) {
    yield put({
      type: GET_BO_COMPANY_BOARD,
      payload: [],
    });
    yield put({
      type: DO_SWITCH_OFF, payload: tf('backOffice').bo_list_board,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOUpdateBoard({ payload }) {
  const companyId = localStorage.getItem('company_id');
  yield put({
    type: DO_LOADING, payload: true,
  });
  try {
    const response = yield call(apiBOUpdateBoard, payload);
    yield put({
      type: HIT_BO_COMPANY_BOARD,
      payload: {
        company_id: companyId,
      },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: response.message,
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({
      type: DO_LOADING, payload: false,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardProcess({ payload }) {
  try {
    const values = yield call(apiBOListProcess, payload);
    yield put({
      type: GET_BO_BOARD_PROCESS,
      payload: values,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardStructure({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_list_structure });
  try {
    const values = yield call(apiBOListStructure, payload);
    yield put({
      type: GET_BO_BOARD_STRUCTURE,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_list_structure });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_BOARD_STRUCTURE,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_list_structure });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBODetailStructure({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_detail_structure });
  try {
    const values = yield call(apiBODetailStructure, payload);
    yield put({
      type: GET_BO_DETAIL_STRUCTURE,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_detail_structure });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_DETAIL_STRUCTURE,
      payload: null,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_detail_structure });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOImportAddOrganization({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const response = yield call(apiBOImportAddOrganization, payload);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: response.message,
      },
    });
    yield put({
      type: HIT_BO_BOARD_STRUCTURE,
      payload: {
        company_id: localStorage.getItem('company_id'),
        board_id: localStorage.getItem('board_id'),
        limit: 10,
        offset: 0,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    const dataError = error.raw.data;
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        tempData: dataError,
        message: error.message,
        listView: Object.keys(dataError).length !== 0 ? 'listView' : '',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOImportUpdateStructure({ payload }) {
  const companyId = localStorage.getItem('company_id');
  const boardId = localStorage.getItem('board_id');
  yield put({ type: DO_LOADING, payload: true });
  try {
    const response = yield call(apiBOImportUpdateStructure, payload);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: response.message,
      },
    });
    yield put({
      type: HIT_BO_BOARD_STRUCTURE,
      payload: {
        company_id: companyId,
        board_id: boardId,
        limit: 10,
        offset: 0,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    const dataError = error.raw.data;
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        tempData: dataError,
        message: error.message,
        listView: Object.keys(dataError).length !== 0 ? 'listView' : '',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOImportUpdateEmployee({ payload }) {
  const companyId = localStorage.getItem('company_id');
  const boardId = localStorage.getItem('board_id');
  yield put({ type: DO_LOADING, payload: true });
  try {
    const response = yield call(apiBOImportUpdateEmployee, payload);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: response.message,
      },
    });
    yield put({
      type: HIT_BO_BOARD_EMPLOYEE,
      payload: {
        company_id: companyId,
        board_id: boardId,
        limit: 10,
        offset: 0,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    const dataError = error.raw.data;
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        tempData: dataError,
        message: error.message,
        listView: Object.keys(dataError).length !== 0 ? 'listView' : '',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOImportAnotherBoardStructure({ payload }) {
  const companyId = localStorage.getItem('company_id');
  const boardId = localStorage.getItem('board_id');
  yield put({ type: DO_LOADING, payload: true });
  try {
    const response = yield call(apiBOImportBoardStructure, payload);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: response.message,
      },
    });
    yield put({
      type: HIT_BO_BOARD_STRUCTURE,
      payload: {
        company_id: companyId,
        board_id: boardId,
        limit: 10,
        offset: 0,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    const dataError = error.raw.data;
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        // tempData: dataError,
        message: error.message,
        // listView: Object.keys(dataError).length !== 0 ? 'listView' : '',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOImportAnotherBoardEmployee({ payload }) {
  const companyId = localStorage.getItem('company_id');
  const boardId = localStorage.getItem('board_id');
  yield put({ type: DO_LOADING, payload: true });
  try {
    const response = yield call(apiBOImportBoardEmployee, payload);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: response.message,
      },
    });
    yield put({
      type: HIT_BO_BOARD_EMPLOYEE,
      payload: {
        company_id: companyId,
        board_id: boardId,
        limit: 10,
        offset: 0,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    const dataError = error.raw.data;
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        // tempData: dataError,
        message: error.message,
        // listView: Object.keys(dataError).length !== 0 ? 'listView' : '',
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOAddStructure({ payload }) {
  const { dataCreate, dataList } = payload;
  const companyId = localStorage.getItem('company_id');
  yield put({
    type: DO_LOADING, payload: true,
  });
  try {
    const response = yield call(apiBOCreateStructure, dataCreate);
    yield put({
      type: HIT_BO_BOARD_STRUCTURE,
      payload: dataList,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: response.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOUpdateStructure({ payload }) {
  const { dataUpdate, dataList } = payload;
  yield put({
    type: DO_LOADING, payload: true,
  });

  try {
    const response = yield call(apiBOUpdateStructure, dataUpdate);
    yield put({
      type: HIT_BO_BOARD_STRUCTURE,
      payload: dataList,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: response.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOExportStructure({ payload }) {
  const { dataPayload, resolve, reject } = payload;
  try {
    const result = yield call(apiBOListStructure, dataPayload);
    yield put({
      type: EXPORT_BO_STRUCTURE_SUCCESS,
      payload: result.data,
    });
    // throw new Error('The feature is still under development');
    resolve(result.data);
  } catch (error) {
    reject(error);
  }
}

function* hitBOExportEmployee({ payload }) {
  const { dataPayload, resolve, reject } = payload;
  try {
    const result = yield call(apiBOListEmployee, dataPayload);
    // yield delay(1000);
    yield put({
      type: EXPORT_BO_EMPLOYEE_SUCCESS,
      payload: result.data,
    });
    resolve(result.data);
  } catch (error) {
    reject(error);
  }
}

function* hitBOJobLevel({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_job_level });
  try {
    const response = yield call(apiBOJobLevel, payload);
    yield put({
      type: GET_BO_JOB_LEVEL,
      payload: response,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_job_level });
  } catch (error) {
    yield put({
      type: GET_BO_JOB_LEVEL,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_job_level });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOCompSkillGroup({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_report_to });
  try {
    const response = yield call(apiBOReportTo, payload);
    yield put({
      type: GET_BO_REPORT_TO,
      payload: response,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_report_to });
  } catch (error) {
    yield put({
      type: GET_BO_REPORT_TO,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_report_to });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardEmployee({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_list_employee });
  try {
    const values = yield call(apiBOListEmployee, payload);
    yield put({
      type: GET_BO_BOARD_EMPLOYEE,
      payload: values,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_list_employee });
  } catch (error) {
    yield put({
      type: GET_BO_BOARD_EMPLOYEE,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_list_employee });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOUpdateEmployee({ payload }) {
  const { requestUpdate, requestList } = payload;
  yield put({ type: DO_LOADING, payload: true });
  try {
    const response = yield call(apiBOUpdateEmployee, requestUpdate);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: response.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BO_BOARD_EMPLOYEE,
      payload: {
        board_id: localStorage.getItem('board_id'),
        limit: requestList.limit,
        offset: requestList.offset,
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardCategoryGroup({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_category_group });
  try {
    const values = yield call(apiBOCategoryGroup, payload);
    yield put({
      type: GET_BO_CATEGORY_GROUP,
      payload: values,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_category_group });
  } catch (error) {
    yield put({
      type: GET_BO_CATEGORY_GROUP,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_category_group });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardClassification({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_classification });
  try {
    const values = yield call(apiBOClassification, payload);
    yield put({
      type: GET_BO_CLASSIFICATION,
      payload: values,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_classification });
  } catch (error) {
    yield put({
      type: GET_BO_CLASSIFICATION,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_classification });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardActivityType({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_activityType });
  try {
    const values = yield call(apiBOActivityType, payload);
    yield put({
      type: GET_BO_ACTIVITY_TYPE,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_activityType });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_ACTIVITY_TYPE,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_activityType });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardCompLibrary({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_compLibrary });
  try {
    const values = yield call(apiBOCompLibrary, payload);
    yield put({
      type: GET_BO_COMPETENCY_LIBRARY,
      payload: {
        datas: values,
        type: payload.type,
      },
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_compLibrary });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_COMPETENCY_LIBRARY,
      payload: {
        datas: [],
        type: payload.type,
      },
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_compLibrary });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardOrgParameter({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_orgParameter });
  try {
    const values = yield call(apiBOOrgParameter, payload);
    yield put({
      type: GET_BO_CUSTOM_ORG_PARAMETER,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_orgParameter });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_CUSTOM_ORG_PARAMETER,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_orgParameter });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardDirectorate({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_directorate });
  try {
    const values = yield call(apiBODirectorate, payload);
    yield put({
      type: GET_BO_DIRECTORATE,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_directorate });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_DIRECTORATE,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_directorate });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardFTE({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_fte });
  try {
    const values = yield call(apiBOFTE, payload);
    yield put({
      type: GET_BO_FTE,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_fte });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_FTE,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_fte });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardLevelDesc({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_levelDesc });
  try {
    const values = yield call(apiBOLevelDesc, payload);
    yield put({
      type: GET_BO_LEVEL_DESCRIPTION,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_levelDesc });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_LEVEL_DESCRIPTION,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_levelDesc });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardMember({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_member });
  try {
    const values = yield call(apiBOMember, payload);
    yield put({
      type: GET_BO_MEMBER,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_member });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_MEMBER,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_member });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardRegion({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_region });
  try {
    const values = yield call(apiBORegion, payload);
    yield put({
      type: GET_BO_REGION,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_region });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_REGION,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_region });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardSkillGroup({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_skillGroup });
  try {
    const values = yield call(apiBOSkillGroup, payload);
    yield put({
      type: GET_BO_SKILL_GROUP,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_skillGroup });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_SKILL_GROUP,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_skillGroup });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardSubSkillGroup({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_sub_skill_group });
  try {
    const values = yield call(apiBOSubSkillGroup, payload);
    yield put({
      type: GET_BO_SUB_SKILL_GROUP,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_sub_skill_group });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_SUB_SKILL_GROUP,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_sub_skill_group });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBOCompetencyDetail({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_competency_detail });
  try {
    const values = yield call(apiBOCompDetail, payload);
    yield put({
      type: GET_BO_COMPETENCY_DETAIL,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_competency_detail });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_COMPETENCY_DETAIL,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_competency_detail });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitBoardWorkerType({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('backOffice').bo_workerType });
  try {
    const values = yield call(apiBOWorkerType, payload);
    yield put({
      type: GET_BO_WORKER_TYPE,
      payload: values,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_workerType });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: GET_BO_WORKER_TYPE,
      payload: [],
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('backOffice').bo_workerType });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitValidationWLA({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiValidationWLA, payload.data);
    yield put({
      type: GET_VALIDATION_WLA,
      payload: index,
    });
    if (
      index.form // 👈 null and undefined check
      && Object.keys(index.form)?.length === 0
    ) {
      yield put({ type: DO_LOADING, payload: false });
      yield put({ type: DO_TRIGGER, payload: random() });
      yield put({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'failed',
          message: "User doesn't ready to fill the Form!",
        },
      });
    } else {
      yield put({ type: DO_LOADING, payload: false });
      yield put({ type: DO_TRIGGER, payload: random() });
      if (
        index.data_form.status === 'open'
        && index.data_form?.data_form?.length > 0
      ) {
        payload.history.push(
          `/workload-landing-v2/onsave/1?company_code=${payload.data.company_code}`,
        );
        // payload.history.push(
        //   `/workload-landing/onsave/1?company_code=${payload.data.company_code}`,
        // );
      } else {
        payload.history.push(
          `/workload-landing-v2/1?company_code=${payload.data.company_code}`,
        );
      }
    }
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitOnSaveWLA({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiOnSaveWLA, payload.data);
    if (index.data?.status === 'open') {
      yield put({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'success',
          message: index.message,
        },
      });
    } else {
      yield put({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'success',
          message: index.message,
        },
      });
    }
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });

    if (index.data?.status === 'open') {
      // payload.history.push("/workload-landing/success_onsave");
    } else {
      payload.history.push('/workload-landing/success_finalsubmit');
    }
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* hitWorkerTypeCreate({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiWlaCreate, payload);

    yield put({
      type: HIT_WORKER_TYPE_LIST,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitWorkerTypeList({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('company').companyWorkerType });
  try {
    const index = yield call(apiWlaList, payload);
    yield put({
      type: GET_WORKER_TYPE_LIST,
      payload: index,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyWorkerType,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyWorkerType,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaDashboardEmployee({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiWlaDashboardEmployee, payload);
    yield put({
      type: GET_WLA_DASHBOARD_EMPLOYEE,
      payload: index,
    });
    const wtp_id = yield call(apiWlaList, {
      worker_type_id: index[0].worker_type_id,
    });
    yield put({
      type: GET_WORKER_TYPE_LIST,
      payload: wtp_id,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaDashboardEmployeeRegion({ payload }) {
  yield put({
    type: DO_SWITCH_ON,
    payload: tf('wlaAnalytics').detailPersonnel,
  });
  try {
    const index = yield call(apiListEmployeeRegion, payload);
    yield put({
      type: GET_WLA_DASHBOARD_EMPLOYEE_REGION,
      payload: index,
    });
    const wtp_id = yield call(apiWlaList, {
      worker_type_id: index[0].worker_type_id,
    });
    yield put({
      type: GET_WORKER_TYPE_LIST,
      payload: wtp_id,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailPersonnel,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailPersonnel,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaDashboardDivision({ payload, loading = true }) {
  if (loading) {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('wlaAnalytics').detailAnalytics,
    });
  }
  try {
    const index = yield call(apiWlaDashboardDivision, payload);
    yield put({
      type: GET_WLA_DASHBOARD_DIVISION,
      payload: index,
    });
    if (loading) {
      yield put({
        type: DO_SWITCH_OFF,
        payload: tf('wlaAnalytics').detailAnalytics,
      });
      yield put({ type: DO_TRIGGER, payload: random() });
    }
  } catch (error) {
    yield put({
      type: GET_WLA_DASHBOARD_DIVISION,
      payload: {},
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailAnalytics,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaDashboardDepartement({ payload }) {
  yield put({
    type: DO_SWITCH_ON,
    payload: tf('wlaAnalytics').detailOrgStructure,
  });
  try {
    const index = yield call(apiWlaDashboardOrg, payload);
    yield put({
      type: GET_WLA_DASHBOARD_DEPARTEMENT,
      payload: index,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailOrgStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailOrgStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaDashboardJobLevel({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiWlaDashboardJobLvl, payload);
    yield put({
      type: GET_WLA_DASHBOARD_JOBLVL,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaStatus({ payload }) {
  // yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiWlaStatus, payload);
    yield put({
      type: GET_WLA_DASHBOARD_EMPLOYEE,
      payload: {
        action: 'update',
      },
    });

    if (!payload.employee) {
      yield put({
        type: GET_WLA_LIST,
        payload: {
          action: 'update',
          status: payload.status,
          index: payload.index,
        },
      });
    }

    payload.toast.success(index.message, {
      containerId: 'wlaMonitor',
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    payload.toast.error(error.message, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaListStatus({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('wlaMonitor').listMonitor });
  try {
    const index = yield call(apiWlaListStatus, payload);
    yield put({
      type: GET_WLA_LIST,
      payload: index,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('wlaMonitor').listMonitor });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('wlaMonitor').listMonitor });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: GET_WLA_LIST, payload: [] });
  }
}
function* hitWlaDetailStatus({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('wlaMonitor').detailMonitor });

  try {
    const index = yield call(apiWlaDetailStatus, payload);
    yield put({
      type: GET_WLA_DETAIL,
      payload: index,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('wlaMonitor').detailMonitor });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('wlaMonitor').detailMonitor });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitWlaDetailStructure({ payload }) {
  const { data } = payload;
  yield put({ type: DO_LOADING, payload: true });

  try {
    yield put({
      type: GET_WLA_DETAIL_STRUCTURE,
      payload: data,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitExportDataActivity({ payload }) {
  yield put({ type: DO_LOADING, payload: true });

  try {
    const index = yield call(apiExportDataActivity, payload.data);
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: GET_EXPORT_DATA_ACTIVITY,
      payload: index,
    });
    payload.func(index, 'activity');
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitExportDataOverall({ payload }) {
  yield put({ type: DO_LOADING, payload: true });

  try {
    const index = yield call(apiExportDataOverall, payload.data);
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: GET_EXPORT_DATA_OVERALL,
      payload: index,
    });
    payload.func(index, 'overall');
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitListStructureEmployee({ payload, loading = true }) {
  if (loading) {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('wlaAnalytics').personelAnalytics,
    });
  }
  try {
    const index = yield call(apiStructureEmployee, payload);
    yield put({
      type: GET_STRUCTURE_EMPLOYEE,
      payload: index,
    });
    // payload.func(index, "overall");
    if (loading) {
      yield put({
        type: DO_SWITCH_OFF,
        payload: tf('wlaAnalytics').personelAnalytics,
      });
      yield put({ type: DO_TRIGGER, payload: random() });
    }
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').personelAnalytics,
    });
    yield put({
      type: GET_STRUCTURE_EMPLOYEE,
      payload: [],
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitOtherCategoryBoard({ payload, loading = true }) {
  try {
    const index = yield call(apiBoardOtherCategory, payload);

    yield put({
      type: GET_WLA_OC_BOARD,
      payload: index,
    });
    if (loading) {
      yield put({ type: DO_TRIGGER, payload: random() });
    }
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitOtherCategoryDepartement({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiListOtherCategoryDepartment, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: GET_WLA_OC_DEPARTEMENT,
      payload: index,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitOtherCategoryOrg({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiListOtherCategoryOrg, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: GET_WLA_OC_ORG,
      payload: index,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitOtherCategoryEmployee({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiListOtherCategoryEmployee, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: GET_WLA_OC_EMPLOYEE,
      payload: index,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitOtherCategoryList({ payload }) {
  try {
    yield put({
      type: DO_SWITCH_ON,
      payload: tf('company').companyClassification,
    });
    const index = yield call(apiListOtherCategory, payload);
    yield put({
      type: GET_WLA_OC_LIST,
      payload: {
        data: index,
        // type: payload.type,
      },
    });
    // payload.func(index, 'overall');
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyClassification,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyClassification,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitOtherCategoryCreate({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiCreateOtherCategory, payload.data);

    yield put({
      type: HIT_WLA_OC_LIST,
    });

    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    // yield put({
    //   type: GET_WLA_OC_LIST,
    //   payload: {
    //     insert_data: true,
    //     data: {
    //       title: index.title,
    //       wla_category_id: index.wla_category_id
    //     },
    //     id: payload.id,
    //     type: payload.type
    //   }
    // });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitOtherCategoryUpdate({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const update = yield call(apiUpdateOtherCategory, payload.data);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_WLA_OC_LIST,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: update.message,
      },
    });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaAssessment({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    yield call(apiPostAssessmentWLA, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: 'Create Assessment is successfully!',
      },
    });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaSubmitTemplate({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    yield call(apiPostWlaTemplate, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaListTemplate({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiListWlaTemplate, payload);
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: GET_WLA_LIST_TEMPLATE,
      payload: index,
    });
  } catch (error) {
    yield put({
      type: GET_WLA_LIST_TEMPLATE,
      payload: [],
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaProgressSummary({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('wlaMonitor').cardMonitor });
  try {
    const index = yield call(apiWlaProgressSummary, payload);
    yield put({
      type: GET_WLA_PROGRESS_SUMMARY,
      payload: index,
    });
    yield put({ type: DO_SIWTCH_OFF, payload: tf('wlaMonitor').cardMonitor });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('wlaMonitor').cardMonitor });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaChartProcess({ payload }) {
  yield put({
    type: DO_SWITCH_ON,
    payload: tf('wlaAnalytics').processAnalytics,
  });
  try {
    const index = yield call(apiWlaProcessChart, payload);
    yield put({
      type: GET_WLA_CHART_PROCESS,
      payload: index,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').processAnalytics,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').processAnalytics,
    });
    yield put({
      type: GET_WLA_CHART_PROCESS,
      payload: [],
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWlaBarChart({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('wlaAnalytics').barAnalytics });
  try {
    const index = yield call(apiBarChart, payload);
    yield put({
      type: GET_WLA_BAR_CHART,
      payload: index,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').barAnalytics,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').barAnalytics,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitWlaDetailOrg({ payload }) {
  const { board_id, organizationId } = payload;
  yield put({
    type: DO_SWITCH_ON,
    payload: tf('wlaAnalytics').detailOrgStructure,
  });
  try {
    const index = yield call(apiDetailChart, board_id);
    const dataDetail = index.find(
      (data) => data.organization_id === organizationId,
    );
    yield put({
      type: GET_WLA_DETAIL_ORG,
      payload: dataDetail,
    });

    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailOrgStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailOrgStructure,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitWlaOrgProcess({ payload }) {
  yield put({
    type: DO_SWITCH_ON,
    payload: tf('wlaAnalytics').detailWlaProcess,
  });
  try {
    const index = yield call(apiWlaProcessDetail, payload);

    yield put({
      type: GET_WLA_ORG_PROCESS,
      payload: index,
    });

    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailWlaProcess,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailWlaProcess,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitWlaOrgListProcess({ payload }) {
  yield put({
    type: DO_SWITCH_ON,
    payload: tf('wlaAnalytics').detailWlaListProcess,
  });
  try {
    const index = yield call(apiWlaProcessList, payload);

    yield put({
      type: GET_WLA_LIST_PROCESS,
      payload: index,
    });

    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailWlaListProcess,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('wlaAnalytics').detailWlaListProcess,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitCompetencyMove({ payload }) {
  const { payloadMove, payloadList } = payload;
  yield put({ type: DO_SWITCH_ON, payload: tf('company').competency_move });
  try {
    const index = yield call(apiCompetencyMove, payloadMove);

    yield put({
      type: HIT_COMPETENCY_LIB,
      payload: payloadList,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').competency_move });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').competency_move });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitActivityTypeList({ payload }) {
  yield put({ type: DO_SWITCH_ON, payload: tf('company').companyType });
  try {
    const index = yield call(apiListActivityType, payload);
    yield put({
      type: GET_ACTIVITY_TYPE_LIST,
      payload: index,
    });
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').companyType });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_SWITCH_OFF, payload: tf('company').companyType });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitActivityTypeCreate({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiCreateActivityType, payload.data);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({
      type: HIT_ACTIVITY_TYPE_LIST,
    });
    // yield put({
    //   type: GET_ACTIVITY_TYPE_LIST,
    //   payload: {
    //     data: index,
    //     insert_data: true
    //   }
    // });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitActivityTypeUpdate({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiUpdateActivityType, payload.data);
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({
      type: GET_ACTIVITY_TYPE_LIST,
      payload: { data: index.data, update_data: true, id: payload.id },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitListLimitFte({ payload }) {
  yield put({
    type: DO_SWITCH_ON,
    payload: tf('company').companyFTEClassification,
  });
  try {
    const index = yield call(apiListLimitFTE, payload);
    yield put({
      type: GET_LIST_LIMIT_FTE,
      payload: index,
    });
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyFTEClassification,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: DO_SWITCH_OFF,
      payload: tf('company').companyFTEClassification,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}

function* hitListCustomCategory({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiListOtherCategoryPublic, payload);
    yield put({
      type: GET_LIST_CUSTOM_CATEGORY,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitListLimitFtePublic({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiListLimitFTEPublic, payload);
    yield put({
      type: GET_LIST_LIMIT_FTE,
      payload: index,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitCreateLimitFte({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiCreateLimitFTE, payload.data);
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_LIST_LIMIT_FTE,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}
function* hitUpdateLimitFte({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiUpdateLimitFTE, payload.data);
    yield put({
      type: GET_LIST_LIMIT_FTE,
      payload: { data: index.data, update_data: true, id: payload.id },
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  }
}
function* hitWorkerTypeUpdate({ payload }) {
  yield put({ type: DO_LOADING, payload: true });
  try {
    const index = yield call(apiWlaUpdate, payload.data);
    yield put({
      type: HIT_WORKER_TYPE_LIST,
    });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'success',
        message: index.message,
      },
    });
    // yield put({
    //   type: GET_WORKER_TYPE_LIST,
    //   payload: {
    //     data: index,
    //     id: payload.id
    //   }
    // });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUS,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* getPopUp({ payload }) {
  yield put({
    type: HIT_BOARD_STATUS,
    payload: {
      status: payload.status,
      message: payload.message,
    },
  });
}

function* getLoginV2({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    let loginV2;

    if (payload.history === 'admin') {
      loginV2 = yield call(apiLoginAdminV2, payload.data);
    } else {
      loginV2 = yield call(apiLoginEmployeeV2, payload.data);
    }
    yield put({
      type: GET_LOGINV2,
      payload: loginV2.data,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: loginV2.message,
      },
    });
  } catch (error) {
    yield put({
      type: GET_LOGINV2,
      payload: 'error',
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: HIT_BOARD_STATUS, payload: 'failed' });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
    return false;
  }
}
function* getDataDashboard({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiOkrDashboard);
    yield put({
      type: GET_OKR_DASHBOARD,
      payload: datas,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: HIT_BOARD_STATUS, payload: 'failed' });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getTeamDashboard({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiTeamDashboard);
    yield put({
      type: GET_TEAM_DASHBOARD,
      payload: datas,
    });
    // yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: HIT_BOARD_STATUS, payload: 'failed' });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getDepartmentDashboard({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiDepartmentDashboard);
    yield put({
      type: GET_DEPARTMENT_DASHBOARD,
      payload: datas,
    });
    // yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: HIT_BOARD_STATUS, payload: 'failed' });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getDataOkr({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    // const datas = yield call(apiOkrList);
    let datas = [];
    switch (payload) {
      case 1:
        {
          datas = yield call(apiOkrListDepartmen);
        }
        break;
      case 2:
        {
          datas = yield call(apiOkrListTeam);
        }
        break;
      case 'employee':
        {
          datas = yield call(apiAllList, payload);
        }
        break;

      default:
        {
          datas = yield call(apiAllList, payload);
        }
        break;
    }
    yield put({
      type: GET_OKR_LIST,
      payload: datas,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: HIT_BOARD_STATUS, payload: 'failed' });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* getOkrDetail({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiDetailOkr, payload.id);
    yield put({
      type: GET_OKR_DETAIL,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* hitAddAssignment({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiAssignment, payload.data);
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'successfully!',
        messageV2: 'Data berhasil ditambahkan',
      },
    });
    switch (payload.typeOkr) {
      case 'okr':
        const getList = yield call(apiAllList);
        yield put({
          type: GET_OKR_LIST,
          payload: getList,
        });
        break;
      case 'okr_employee':
        const getListEmployee = yield call(apiAllList, 'employee');
        yield put({
          type: GET_OKR_LIST,
          payload: getListEmployee,
        });
        break;

      case 'initiative':
        const getInitiative = yield call(apiInitiativeList);
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiative,
        });
        break;
      case 'initiative-employee':
        const getInitiativeEmployee = yield call(apiInitiativeList, 'employee');
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiativeEmployee,
        });
        break;

      case 'action_plan':
        const getActionPlan = yield call(apiActionplanList);
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlan,
        });
        break;
      case 'action_plan_employee':
        const getActionPlanEmployee = yield call(apiActionplanList, 'employee');
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlanEmployee,
        });
        break;

      case 'detail':
        const getDetail = yield call(apiDetailOkr, payload.data.okr_id);
        yield put({
          type: GET_OKR_DETAIL,
          payload: getDetail,
        });
        break;

      default:
        break;
    }

    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    // yield put({ type: HIT_OKR_LIST });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* hitDelAssignment({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiDelAssignment, payload.data);
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* getDataInitiative({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    let datas = [];
    switch (payload) {
      case 1:
        {
          datas = yield call(apiInitiativeListDepartment);
        }
        break;
      case 2:
        {
          datas = yield call(apiInitiativeListTeam);
        }
        break;
      case 'employee':
        {
          datas = yield call(apiInitiativeList, payload);
        }
        break;

      default:
        {
          datas = yield call(apiInitiativeList);
        }
        break;
    }
    yield put({
      type: GET_INITIATIVE_LIST,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        status: 'failed',
        message: error.message,
      },
    });
  }
}

function* getInitiativeDetail({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiInitiativeDetail, payload.id);
    yield put({
      type: GET_INITIATIVE_DETAIL,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* getDataActionplan({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    let datas = [];
    switch (payload) {
      case 1:
        {
          datas = yield call(apiActionplanListDepartment);
        }
        break;
      case 2:
        {
          datas = yield call(apiActionplanListTeam);
        }
        break;
      case 'employee':
        {
          datas = yield call(apiActionplanList, payload);
        }
        break;

      default:
        {
          datas = yield call(apiActionplanList);
        }
        break;
    }

    yield put({
      type: GET_ACTIONPLAN_LIST,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* getListMeasurenment({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiListMeasurenment);
    yield put({ type: GET_LIST_MEASURENMENT, payload: datas });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* getListProcess({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiListProcess, payload);
    yield put({ type: GET_LIST_PROCESS, payload: datas });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* hitAddOkr({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiAddOkr, payload.data);
    yield put({ type: GET_OKR_RESPONSE, payload: datas });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'Berhasil menambahkan data !',
        messageV2:
          'Silahkan cek kembali data karyawan yang telah Anda tambahkan ke sistem',
      },
    });

    switch (payload.isPosition) {
      case 'okr':
        const getList = yield call(apiAllList);
        yield put({
          type: GET_OKR_LIST,
          payload: getList,
        });
        break;

      case 'okr_employee':
        const getListEmployee = yield call(apiAllList, 'employee');
        yield put({
          type: GET_OKR_LIST,
          payload: getListEmployee,
        });
        break;

      case 'initiative':
        const getInitiative = yield call(apiInitiativeList);
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiative,
        });
        break;

      case 'initiative-employee':
        const getInitiativeEmployee = yield call(apiInitiativeList, 'employee');
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiativeEmployee,
        });
        break;

      case 'action_plan':
        const getActionPlan = yield call(apiActionplanList);
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlan,
        });
        break;

      case 'action_plan_employee':
        const getActionPlanEmployee = yield call(apiActionplanList, 'employee');
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlanEmployee,
        });
        break;

      default:
        break;
    }
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* hitEditOkr({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiEditOkr, payload.data);
    yield put({ type: GET_OKR_RESPONSE, payload: datas });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'Berhasil memperbarui data !',
        messageV2: 'Silahkan cek kembali data karyawan yang telah anda perbarui',
      },
    });

    if (payload?.isProcessBisnis) {
      const getDetail = yield call(apiDetailOkr, payload.data.okr_id);
      yield put({
        type: GET_OKR_DETAIL,
        payload: getDetail,
      });
    } else {
      switch (payload.isPosition) {
        case 'okr':
          const getList = yield call(apiAllList);
          yield put({
            type: GET_OKR_LIST,
            payload: getList,
          });
          break;

        case 'okr_employee':
          const getListEmployee = yield call(apiAllList, 'employee');
          yield put({
            type: GET_OKR_LIST,
            payload: getListEmployee,
          });
          break;

        case 'initiative':
          const getInitiative = yield call(apiInitiativeList);
          yield put({
            type: GET_INITIATIVE_LIST,
            payload: getInitiative,
          });
          break;

        case 'initiative_employee':
          const getInitiativeEmployee = yield call(
            apiInitiativeList,
            'employee',
          );
          yield put({
            type: GET_INITIATIVE_LIST,
            payload: getInitiativeEmployee,
          });
          break;

        case 'action_plan':
          const getActionPlan = yield call(apiActionplanList);
          yield put({
            type: GET_ACTIONPLAN_LIST,
            payload: getActionPlan,
          });
          break;

        case 'action_plan_employee':
          const getActionPlanEmployee = yield call(
            apiActionplanList,
            'employee',
          );
          yield put({
            type: GET_ACTIONPLAN_LIST,
            payload: getActionPlanEmployee,
          });
          break;

        default:
          break;
      }
    }
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* hitDuplicateOkr({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiDuplicateOkr, payload.data);
    // yield put({ type: GET_OKR_RESPONSE, payload: datas });

    switch (payload.isPosition) {
      case 'okr':
        const getList = yield call(apiAllList);
        yield put({
          type: GET_OKR_LIST,
          payload: getList,
        });
        break;

      case 'okr_employee':
        const getListEmployee = yield call(apiAllList, 'employee');
        yield put({
          type: GET_OKR_LIST,
          payload: getListEmployee,
        });
        break;

      case 'initiative':
        const getInitiative = yield call(apiInitiativeList);
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiative,
        });
        break;

      case 'initiative_employee':
        const getInitiativeEmployee = yield call(apiInitiativeList, 'employee');
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiativeEmployee,
        });
        break;

      case 'action_plan':
        const getActionPlan = yield call(apiActionplanList);
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlan,
        });
        break;

      case 'action_plan_employee':
        const getActionPlanEmployee = yield call(apiActionplanList, 'employee');
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlanEmployee,
        });
        break;

      default:
        break;
    }
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'Berhasil duplicate data !',
        // messageV2: "Silahkan cek kembali data yang telah anda tambahkan"
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* hitDeleteOkr({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiDeleteOkr, payload.data);

    switch (payload.isPosition) {
      case 'okr':
        const getList = yield call(apiAllList);
        yield put({
          type: GET_OKR_LIST,
          payload: getList,
        });
        break;

      case 'okr_employee':
        const getListEmployee = yield call(apiAllList, 'employee');
        yield put({
          type: GET_OKR_LIST,
          payload: getListEmployee,
        });
        break;

      case 'initiative':
        const getInitiative = yield call(apiInitiativeList);
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiative,
        });
        break;

      case 'initiative_employee':
        const getInitiativeEmployee = yield call(apiInitiativeList, 'employee');
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiativeEmployee,
        });
        break;

      case 'action_plan':
        const getActionPlan = yield call(apiActionplanList);
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlan,
        });
        break;

      case 'action_plan_employee':
        const getActionPlanEmployee = yield call(apiActionplanList, 'employee');
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlanEmployee,
        });
        break;

      default:
        break;
    }
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'Berhasil delete data !',
        // messageV2: "Silahkan cek data yang telah di perbarui"
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* getPtListEmployee({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtListAllEmployee, payload);
    yield put({
      type: GET_PT_LIST_EMPLOYEE,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getPtListEmployeeManagement({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtListEmployeeManagement, payload);
    yield put({
      type: GET_PT_LIST_EMPLOYEE_MANAGMENT,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getPtListBoard({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtListBoard);
    yield put({
      type: GET_PT_LIST_BOARD,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* hitPtAddEmployee({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    yield call(apiPtCreateEmployee, payload);
    const datas = yield call(apiPtListAllEmployee);
    yield put({
      type: GET_PT_LIST_EMPLOYEE,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'Penambahan data karyawan berhasil!',
        messageV2:
          'Silahkan cek kembali data karyawan yang telah anda tambahkan ke sistem',
      },
    });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getPtListStructure({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtListStructure, payload);
    yield put({
      type: GET_PT_LIST_STRUCTURE,
      payload: { ...datas, detail: payload.detail },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getPtListJobLevel({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtListJobLevel, payload);
    yield put({
      type: GET_PT_LIST_JOB_LEVEL,
      payload: { ...datas, detail: payload.detail },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getPtListDepartment({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtListDepartment, payload);
    yield put({
      type: GET_PT_DEPARTEMENT,
      payload: { ...datas, detail: payload.detail },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* hitPtAddDepartment({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtAddDepartment);
    yield put({
      type: GET_PT_DEPARTEMENT,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* hitPtUpdateDepartment({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtUpdateDepartment);
    yield put({
      type: GET_PT_DEPARTEMENT,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* hitPtDeleteDepartment({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtDeleteDepartment);
    yield put({
      type: GET_PT_DEPARTEMENT,
      payload: datas,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* postPtDepartmentMember({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtAddDepartmentMember, payload.data);
    yield put({
      type: HIT_PT_DEPARTEMENT,
      payload: {
        detail: true,
        id: payload.data.department_id,
      },
    });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'Berhasil menambahkan data !',
        messageV2: 'Silahkan cek kembali data telah Anda tambahkan ke sistem',
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* getPtTeamManagement({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtListTeamManagement, payload);
    yield put({
      type: GET_PT_TEAM_MANAGEMENT,
      payload: { ...datas, detail: payload.detail },
    });

    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* postPtTeamManagement({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtAddTeamManagement, payload);
    yield put({
      type: GET_PT_TEAM_MANAGEMENT,
      payload: datas,
    });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'Berhasil menambahkan data !',
        messageV2:
          'Silahkan cek kembali data karyawan yang telah Anda tambahkan ke sistem',
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* postPtTeamMember({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtAddTeamMember, payload.data);
    yield put({
      type: HIT_PT_TEAM_MANAGEMENT,
      payload: {
        detail: true,
        id: payload.data.team_id,
      },
    });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'Berhasil menambahkan data !',
        messageV2: 'Silahkan cek kembali data telah Anda tambahkan ke sistem',
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* postPtComment({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    yield call(apiPtComment, payload);
    const getList = yield call(apiDetailOkr, payload.okr_id);
    yield put({
      type: GET_OKR_DETAIL,
      payload: getList,
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getListObjective({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiOkrList);
    yield put({ type: GET_PT_OBJECTIVE_LIST, payload: datas });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* getListKeyresult({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiKeyresultList, payload);
    yield put({ type: GET_PT_KEYRESULT_LIST, payload: datas });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

function* getListInitiative({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiInitiativeList, payload);
    yield put({
      type: GET_PT_INITIATIVE_LIST,
      payload: datas,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getPtHierarchy({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiPtHierarchy, payload.id);
    yield put({
      type: GET_PT_HIERARCHY,
      payload: datas,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* getOkrStatus({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiOkrStatus);
    yield put({
      type: GET_OKR_STATUS,
      payload: datas,
    });
    // yield put({ type: DO_LOADING, payload: false });
    // yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* updateProgress({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    const datas = yield call(apiUpdateProgress, payload.data);

    switch (payload.isPosition) {
      case 'okr':
        const getList = yield call(apiAllList);
        yield put({
          type: GET_OKR_LIST,
          payload: getList,
        });
        break;
      case 'okr_employee':
        const getListEmployee = yield call(apiAllList, 'employee');
        yield put({
          type: GET_OKR_LIST,
          payload: getListEmployee,
        });
        break;

      case 'initiative':
        const getInitiative = yield call(apiInitiativeList);
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiative,
        });
        break;
      case 'initiative_employee':
        const getInitiativeEmployee = yield call(apiInitiativeList, 'employee');
        yield put({
          type: GET_INITIATIVE_LIST,
          payload: getInitiativeEmployee,
        });
        break;

      case 'action_plan':
        const getActionPlan = yield call(apiActionplanList);
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlan,
        });
        break;
      case 'action_plan_employee':
        const getActionPlanEmployee = yield call(apiActionplanList, 'employee');
        yield put({
          type: GET_ACTIONPLAN_LIST,
          payload: getActionPlanEmployee,
        });
        break;

      case 'detail':
        const getDetail = yield call(apiDetailOkr, payload.data.okr_id);
        yield put({
          type: GET_OKR_DETAIL,
          payload: getDetail,
        });
        break;

      default:
        break;
    }
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'success',
        title: 'Berhasil melakukan perubahan data!',
        messageV2: 'Data progress berhasil dirubah',
      },
    });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({ type: DO_LOADING, payload: false });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}
function* postTemporaryAssignment({ payload }) {
  try {
    yield put({ type: DO_LOADING, payload: true });
    yield put({
      type: GET_TEMPORARY_ASSIGNMENT,
      payload,
    });
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
  } catch (error) {
    yield put({ type: DO_LOADING, payload: false });
    yield put({ type: DO_TRIGGER, payload: random() });
    yield put({
      type: HIT_BOARD_STATUSV2,
      payload: {
        statusV2: 'failed',
        title: error.message,
      },
    });
  }
}

export default function* scora() {
  yield takeEvery(POP_UP, getPopUp);
  // auth
  yield takeEvery(HIT_LOGIN, getLogin);
  yield takeEvery(HIT_FORGOT_PASS, postForgotPass);

  // board
  yield takeEvery(HIT_LIST_BOARD, getListBoard);
  yield takeEvery(HIT_LIST_MEMBER_BOARD, getListMemberBoard);
  yield takeEvery(HIT_DELETE_BOARD, deleteBoard);
  yield takeEvery(HIT_ADD_BOARD, createBoard);
  yield takeEvery(HIT_DUPLICATE_BOARD, duplicateBoard);
  yield takeEvery(HIT_UPDATE_BOARD, updateBoard);
  yield takeEvery(HIT_INVITE_BOARD, inviteBoard);
  yield takeEvery(HIT_DASHBOARD_COUNT, dashboardCompany);

  // company
  yield takeEvery(HIT_INVITE_MEMBER, inviteCompanyMember);
  yield takeEvery(HIT_REGISTER, registerCompanyMember);
  yield takeEvery(HIT_LIST_MEMBER, listCompanyMemebr);
  yield takeEvery(HIT_DETAIL_COMPANY, detailCompany);
  yield takeEvery(HIT_UPDATE_CP, updateCompany);
  yield takeEvery(HIT_COMPANY_REGISTER, registerCompany);
  yield takeEvery(HIT_COP_LIST, listCop);
  yield takeEvery(HIT_COP_CREATE, createCop);
  yield takeEvery(HIT_COP_UPDATE, updateCop);

  yield takeEvery(HIT_CUSTOM_MANAGEMENT, listCustomManagement);
  yield takeEvery(HIT_CUSTOM_MANAGEMENT_CREATE, createCustomManagement);
  yield takeEvery(HIT_CUSTOM_MANAGEMENT_UPDATE, updateCustomManagement);

  yield takeEvery(HIT_COMPETENCY_LIB, listCompetencyLib);
  yield takeEvery(HIT_COMPETENCY_LIB_CREATE, createCompetencyLib);
  yield takeEvery(HIT_COMPETENCY_LIB_UPDATE, updateCompetencyLib);
  yield takeEvery(HIT_COMPETENCY_IMPORT, importCompetency);
  yield takeEvery(HIT_COMPETENCY_INQUIRY, inquiryCompetency);
  yield takeEvery(HIT_COMPETENCY_DELETE, deleteCompetency);
  yield takeEvery(HIT_DETAIL_COMPETENCY, getListDetailCompetency);

  yield takeEvery(HIT_LIST_LEVEL_DESCRIPTION, getListLevelDesc);
  yield takeEvery(HIT_CREATE_LEVEL_DESCRIPTION, createLevelDesc);
  yield takeEvery(HIT_UPDATE_LEVEL_DESCRIPTION, updateLevelDesc);
  yield takeEvery(HIT_ACTIVITY_MOVE_ORDER, activityMoveOrder);
  yield takeEvery(HIT_FTE_LIMIT_MOVE_ORDER, fteLimitMoveOrder);

  yield takeEvery(HIT_LIST_SKILL_GROUP, listSkillGroup);
  yield takeEvery(HIT_LIST_SUB_SKILL_GROUP, listSubSkillGroup);
  yield takeEvery(HIT_ACTION_SKILL_GROUP, addSkillGroup);

  // business process
  yield takeEvery(HIT_CVC_LVL_1, getCvcLvl1);
  yield takeEvery(HIT_INDEX_VIEW, getListIndexView);
  yield takeEvery(HIT_DETAIL_BS, getDetailBS);
  yield takeEvery(HIT_CREATE_BS, createBS);
  yield takeEvery(HIT_CREATE_CHILD, createChildTree);
  yield takeEvery(HIT_UPDATE_BS, updateBS);
  yield takeEvery(HIT_DELETE_PROCESS, hitDeleteProcess);
  yield takeEvery(HIT_HIERARCHY, hitHierarchy);
  yield takeEvery(HIT_TREE_VIEW, hitTreeView);
  yield takeEvery(HIT_MOVE_TREE, hitMoveTree);
  yield takeEvery(HIT_ADD_TREE, hitCreateTree);
  yield takeEvery(HIT_IMPORT_PROCESS, hitImportProcess);
  yield takeEvery(HIT_IMPORT_PROCESS_COPY, hitImportProcessCopy);
  yield takeEvery(HIT_LIST_PROCESS_LEVEL, hitProcessLevel);

  // business process
  yield takeEvery(HIT_DASHBOARD, hitDashboard);
  yield takeEvery(HIT_APQC_VER, hitApqcVer__);
  yield takeEvery(HIT_APQC_LIB, hitApqcLib__);
  yield takeEvery(HIT_APQC_TEMPLATE, hitApqcTemplate__);
  yield takeEvery(HIT_ADD_APQC, hitApqcCreate);

  // organization
  yield takeEvery(HIT_LIST_EMPLOYEE, hitEmployee);
  yield takeEvery(HIT_REGION_LIST, hitListRegion);
  yield takeEvery(HIT_REGION_CREATE, hitCreateRegion);
  yield takeEvery(HIT_REGION_UPDATE, hitUpdateRegion);
  yield takeEvery(HIT_ADD_EMPLOYEE, hitCreateEmployee);
  yield takeEvery(HIT_CREATE_EMPLOYEE, hitAddEmployee);
  yield takeEvery(HIT_UPDATE_EMPLOYEE, hitUpdateEmployee);
  yield takeEvery(HIT_EDIT_EMPLOYEE, hitEditEmployee);
  yield takeEvery(HIT_ADD_NODE_EMPLOYEE, hitCreateEmployeeNode);
  yield takeEvery(HIT_UPDATE_NODE_EMPLOYEE, hitUpdateEmployeeNode);
  yield takeEvery(HIT_LIST_ORGANIZATION, hitOrganization);
  yield takeEvery(HIT_LIST_JOB, hitListJob);
  yield takeEvery(HIT_CREATE_JOB_LEVEL, hitCreateJobLvl);
  yield takeEvery(HIT_UPDATE_JOB_LEVEL, hitUpdateJobLvl);
  yield takeEvery(HIT_STRUCTURE, hitViewStructure);
  yield takeEvery(HIT_DETAIL_STRUCTURE, hitViewDetailStructure);
  yield takeEvery(HIT_ADD_STRUCTURE, hitCreateStructure);
  yield takeEvery(HIT_ADD_NODE_STRUCTURE, hitCreateNodeStructure);
  yield takeEvery(HIT_UPDATE_STRUCTURE, hitUpdateStructure);
  yield takeEvery(HIT_EMPLOYEE_CHART, hitEmployeeChart);
  yield takeEvery(HIT_IMPORT_PROCESS_ORG, hitImportProcessOrg);
  yield takeEvery(HIT_FOCUS_POSITION, hitFocusPosition);
  yield takeEvery(HIT_FOCUS_POSITION_EMPLOYEE, hitFocusPositionEmployee);
  yield takeEvery(HIT_BANK_LIST, hitBankList);
  yield takeEvery(HIT_CREATE_STRUCTURE_COPY, hitCreateStructureCopy);
  yield takeEvery(HIT_LIST_DIRECTORATE, hitListDirectorate);
  yield takeEvery(HIT_CREATE_DIRECTORATE, hitCreateDirectorate);
  yield takeEvery(HIT_UPDATE_DIRECTORATE, hitUpdateDirectorate);
  yield takeEvery(HIT_DELETE_DIRECTORATE, hitDeleteDirectorate);
  yield takeEvery(HIT_LIST_DIVISION, hitListDivision);

  // matrix
  yield takeEvery(HIT_VIEW_MATRIX, hitViewMatrix);
  yield takeEvery(HIT_MATRIX_VIEW_STRUCTURE, hitViewMatrixStructure);
  yield takeEvery(HIT_MATRIX_VIEW_PROCESS, hitViewMatrixProcess);
  yield takeEvery(HIT_VIEW_DETAIL_OF_PROCESS, hitViewDetailOfProcess);
  yield takeEvery(HIT_LIST_PERIOD, hitListPeriodMatrix);
  yield takeEvery(HIT_CHANGE_MATRIX, hitChangeMatrix);
  yield takeEvery(HIT_CREATE_MATRIX, hitCreateMatrix);
  yield takeEvery(HIT_MATRIX_STRUCTURE_STATUS, hitStructureMatrix);
  yield takeEvery(HIT_CLOSED_MATRIX, hitClosedMatrix);
  yield takeEvery(HIT_MERGE_MATRIX, hitMergeMatrix);
  yield takeEvery(HIT_LIST_CONFLICT, hitListMatrix);
  yield takeEvery(HIT_PIVOT_DATA, hitListPivot);
  yield takeEvery(HIT_NEW_VIEW_MATRIX, hitViewMatrix_dnd);
  yield takeEvery(HIT_IMPORT_MATRIX, hitImportMatrix);
  yield takeEvery(HIT_SELECTED_MATRIX_FOCUS, hitSelectedMatrixFocus);

  // jobdesc
  yield takeEvery(HIT_LIST_JOBDESC, hitListJobDesc);
  yield takeEvery(HIT_LIST_VERSIONID, hitListVersionID);
  yield takeEvery(HIT_DETAIL_JOBDESC, hitDetailJobDesc);
  yield takeEvery(HIT_HR_APPROVAL, hitHRApproval);
  yield takeEvery(HIT_DETAIL_JOBDESC_V2, hitDetailJobDescV2);
  yield takeEvery(HIT_ORG_STRUCTURE_JOBDESC, hitJobDescOrgStructure);
  yield takeEvery(HIT_MAINRESPO_JOBDESC, hitJobDescMainRespo);
  yield takeEvery(HIT_KPI_JOBDESC, hitJobDescKPI);
  yield takeEvery(HIT_AUTHORITY_JOBDESC, hitJobDescAuthority);
  yield takeEvery(HIT_WORK_RELATION_JOBDESC, hitJobDescWorkRelation);

  // validation
  yield takeEvery(VALIDATION_DASHBOARD, hitValidationDashboard);
  yield takeEvery(VALIDATION_COMPANY, hitValidationCompany);
  yield takeEvery(VALIDATION_MATRIX, hitValidationMatrix);

  // cdn
  // yield takeEvery(HIT_CDN, hitCdnUpload)
  // profile
  yield takeEvery(HIT_PROFILE, hitProfile);
  yield takeEvery(HIT_UPDATE_PROFILE, hitUpdateProfile);

  // back office
  yield takeEvery(HIT_BACKOFFICE_LIST, hitBoCompany);
  yield takeEvery(HIT_BO_SUBSCRIPTION_LIST, hitBoListSubs);
  yield takeEvery(HIT_BO_USER_LIST, hitBoListUser);
  yield takeEvery(HIT_BO_LOG_LIST, hitBoListLog);
  yield takeEvery(HIT_BO_LOG_LIST_FEATURE, hitBoListLogFeature);
  yield takeEvery(HIT_BO_COMPANY_DELETE, hitBoCompanyDelete);
  yield takeEvery(HIT_BO_DASHBOARD, hitBoDashboard);
  yield takeEvery(HIT_BO_FEATURE, hitBoFeatureList);
  yield takeEvery(HIT_BO_SUBS_CREATE, hitBoSubsCreate);
  yield takeEvery(HIT_BO_SUBS_UPDATE, hitBoSubsUpdate);
  yield takeEvery(HIT_BO_USER_CREATE, hitBoUserCreate);
  yield takeEvery(HIT_BO_USER_UPDATE, hitBoUserUpdate);
  yield takeEvery(HIT_BO_APQC_LIB, hitBoAPQC);
  yield takeEvery(HIT_BO_APQC, hitBoAPQCView);
  yield takeEvery(HIT_BO_APQC_UPDATE, hitBoAPQCUpdate);
  yield takeEvery(HIT_BO_APQC_UPDATE_LIBRARY, hitBoAPQCUpdateLibrary);
  yield takeEvery(HIT_BO_APQC_CREATE, hitBoAPQCCreate);
  yield takeEvery(HIT_BO_APQC_MOVE, hitBoAPQCMove);
  yield takeEvery(HIT_BO_APQC_IMPORT, hitBoAPQCImport);
  yield takeEvery(HIT_WORKLOAD_LIST, hitWorkloadList);
  yield takeEvery(HIT_COMPETENCY_CREATE, hitCompetencyCreate);
  yield takeEvery(HIT_COMPETENCY_UPDATE, hitCompetencyUpdate);
  yield takeEvery(HIT_COMPETENCY, hitCompetencyList);
  yield takeEvery(HIT_BO_COMPANY_BOARD, hitBoardCompany);
  yield takeEvery(HIT_BO_UPDATE_BOARD, hitBOUpdateBoard);
  yield takeEvery(HIT_BO_BOARD_PROCESS, hitBoardProcess);
  yield takeEvery(HIT_BO_BOARD_STRUCTURE, hitBoardStructure);
  yield takeEvery(HIT_BO_CREATE_STRUCTURE, hitBOAddStructure);
  yield takeEvery(HIT_BO_UPDATE_STRUCTURE, hitBOUpdateStructure);
  yield takeEvery(HIT_BO_DETAIL_STRUCTURE, hitBODetailStructure);
  yield takeEvery(HIT_BO_IMPORT_ADD_ORGANIZATION, hitBOImportAddOrganization);
  yield takeEvery(HIT_BO_IMPORT_UPDATE_STRUCTURE, hitBOImportUpdateStructure);
  yield takeEvery(HIT_BO_IMPORT_UPDATE_EMPLOYEE, hitBOImportUpdateEmployee);
  yield takeEvery(HIT_BO_IMPORT_ANOTHER_BOARD_STRUCTURE, hitBOImportAnotherBoardStructure);
  yield takeEvery(HIT_BO_IMPORT_ANOTHER_BOARD_EMPLOYEE, hitBOImportAnotherBoardEmployee);
  yield takeEvery(HIT_BO_JOB_LEVEL, hitBOJobLevel);
  yield takeEvery(HIT_BO_BOARD_EMPLOYEE, hitBoardEmployee);
  yield takeEvery(EXPORT_BO_STRUCTURE_REQUEST, hitBOExportStructure);
  yield takeEvery(EXPORT_BO_EMPLOYEE_REQUEST, hitBOExportEmployee);
  yield takeEvery(HIT_BO_UPDATE_EMPLOYEE, hitBOUpdateEmployee);
  yield takeEvery(HIT_BO_CATEGORY_GROUP, hitBoardCategoryGroup);
  yield takeEvery(HIT_BO_CLASSIFICATION, hitBoardClassification);
  yield takeEvery(HIT_BO_ACTIVITY_TYPE, hitBoardActivityType);
  yield takeEvery(HIT_BO_COMPETENCY_LIBRARY, hitBoardCompLibrary);
  yield takeEvery(HIT_BO_CUSTOM_ORG_PARAMETER, hitBoardOrgParameter);
  yield takeEvery(HIT_BO_DIRECTORATE, hitBoardDirectorate);
  yield takeEvery(HIT_BO_FTE, hitBoardFTE);
  yield takeEvery(HIT_BO_LEVEL_DESCRIPTION, hitBoardLevelDesc);
  yield takeEvery(HIT_BO_MEMBER, hitBoardMember);
  yield takeEvery(HIT_BO_REGION, hitBoardRegion);
  yield takeEvery(HIT_BO_SKILL_GROUP, hitBoardSkillGroup);
  yield takeEvery(HIT_BO_SUB_SKILL_GROUP, hitBoardSubSkillGroup);
  yield takeEvery(HIT_BO_COMPETENCY_DETAIL, hitBOCompetencyDetail);
  yield takeEvery(HIT_BO_WORKER_TYPE, hitBoardWorkerType);

  // wla
  yield takeEvery(HIT_VALIDATION_WLA, hitValidationWLA);
  yield takeEvery(HIT_ON_SAVE_WLA, hitOnSaveWLA);
  yield takeEvery(HIT_WORKER_TYPE_CREATE, hitWorkerTypeCreate);
  yield takeEvery(HIT_WORKER_TYPE_UPDATE, hitWorkerTypeUpdate);
  yield takeEvery(HIT_WORKER_TYPE_LIST, hitWorkerTypeList);
  yield takeEvery(HIT_ACTIVITY_TYPE_LIST, hitActivityTypeList);
  yield takeEvery(HIT_ACTIVITY_TYPE_CREATE, hitActivityTypeCreate);
  yield takeEvery(HIT_ACTIVITY_TYPE_UPDATE, hitActivityTypeUpdate);
  yield takeEvery(HIT_LIST_LIMIT_FTE, hitListLimitFte);
  yield takeEvery(HIT_LIST_CUSTOM_CATEGORY, hitListCustomCategory);
  yield takeEvery(HIT_LIST_LIMIT_FTE_PUBLIC, hitListLimitFtePublic);
  yield takeEvery(HIT_CREATE_FTE, hitCreateLimitFte);
  yield takeEvery(HIT_UPDATE_FTE, hitUpdateLimitFte);

  yield takeEvery(HIT_WLA_DASHBOARD_EMPLOYEE, hitWlaDashboardEmployee);
  yield takeEvery(
    HIT_WLA_DASHBOARD_EMPLOYEE_REGION,
    hitWlaDashboardEmployeeRegion,
  );
  yield takeEvery(HIT_WLA_DASHBOARD_DIVISION, hitWlaDashboardDivision);
  yield takeEvery(HIT_WLA_DASHBOARD_DEPARTEMENT, hitWlaDashboardDepartement);
  yield takeEvery(HIT_WLA_DASHBOARD_JOBLVL, hitWlaDashboardJobLevel);
  yield takeEvery(HIT_WLA_STATUS, hitWlaStatus);
  yield takeEvery(HIT_WLA_LIST, hitWlaListStatus);
  yield takeEvery(HIT_WLA_DETAIL, hitWlaDetailStatus);
  yield takeEvery(HIT_WLA_DETAIL_STRUCTURE, hitWlaDetailStructure);

  yield takeEvery(HIT_EXPORT_DATA_ACTIVITY, hitExportDataActivity);
  yield takeEvery(HIT_EXPORT_DATA_OVERALL, hitExportDataOverall);

  yield takeEvery(HIT_STRUCTURE_EMPLOYEE, hitListStructureEmployee);
  yield takeEvery(HIT_WLA_OC_BOARD, hitOtherCategoryBoard);
  yield takeEvery(HIT_WLA_OC_DEPARTEMENT, hitOtherCategoryDepartement);
  yield takeEvery(HIT_WLA_OC_ORG, hitOtherCategoryOrg);
  yield takeEvery(HIT_WLA_OC_EMPLOYEE, hitOtherCategoryEmployee);
  yield takeEvery(HIT_WLA_OC_LIST, hitOtherCategoryList);
  yield takeEvery(HIT_WLA_OC_CREATE, hitOtherCategoryCreate);
  yield takeEvery(HIT_WLA_OC_UPDATE, hitOtherCategoryUpdate);
  yield takeEvery(HIT_WLA_ASSESSMENT, hitWlaAssessment);
  yield takeEvery(HIT_WLA_SUBMIT_TEMPLATE, hitWlaSubmitTemplate);
  yield takeEvery(HIT_WLA_LIST_TEMPLATE, hitWlaListTemplate);
  yield takeEvery(HIT_WLA_PROGRESS_SUMMARY, hitWlaProgressSummary);
  yield takeEvery(HIT_WLA_CHART_PROCESS, hitWlaChartProcess);
  yield takeEvery(HIT_WLA_BAR_CHART, hitWlaBarChart);
  yield takeEvery(HIT_WLA_DETAIL_ORG, hitWlaDetailOrg);
  yield takeEvery(HIT_WLA_ORG_PROCESS, hitWlaOrgProcess);
  yield takeEvery(HIT_WLA_LIST_PROCESS, hitWlaOrgListProcess);
  yield takeEvery(HIT_COMPETENCY_MOVE, hitCompetencyMove);

  // REVAMP LOGIN
  yield takeEvery(HIT_LOGINV2, getLoginV2);
  yield takeEvery(HIT_OKR_DASHBOARD, getDataDashboard);
  yield takeEvery(HIT_TEAM_DASHBOARD, getTeamDashboard);
  yield takeEvery(HIT_DEPARTMENT_DASHBOARD, getDepartmentDashboard);
  yield takeEvery(HIT_OKR_LIST, getDataOkr);
  yield takeEvery(HIT_OKR_DETAIL, getOkrDetail);
  yield takeEvery(HIT_ADD_ASSIGNMENT, hitAddAssignment);
  yield takeEvery(HIT_PT_DEL_ASSIGNMENT, hitDelAssignment);
  yield takeEvery(HIT_INITIATIVE_LIST, getDataInitiative);
  yield takeEvery(HIT_INITIATIVE_DETAIL, getInitiativeDetail);
  yield takeEvery(HIT_ACTIONPLAN_LIST, getDataActionplan);
  yield takeEvery(HIT_ADD_OKR, hitAddOkr);
  yield takeEvery(HIT_EDIT_OKR, hitEditOkr);
  yield takeEvery(HIT_PT_OKR_DUPLICATE, hitDuplicateOkr);
  yield takeEvery(HIT_PT_OKR_DELETE, hitDeleteOkr);
  yield takeEvery(HIT_PT_ADD_EMPLOYEE, hitPtAddEmployee);
  yield takeEvery(HIT_PT_LIST_EMPLOYEE, getPtListEmployee);
  yield takeEvery(HIT_PT_LIST_STRUCTURE, getPtListStructure);
  yield takeEvery(HIT_PT_LIST_JOB_LEVEL, getPtListJobLevel);
  yield takeEvery(HIT_PT_LIST_EMPLOYEE_MANAGEMENT, getPtListEmployeeManagement);
  yield takeEvery(HIT_PT_LIST_BOARD, getPtListBoard);
  yield takeEvery(HIT_PT_DEPARTEMENT, getPtListDepartment);
  yield takeEvery(HIT_PT_ADD_DEPARTEMENT, hitPtAddDepartment);
  yield takeEvery(HIT_PT_UPDATE_DEPARTEMENT, hitPtUpdateDepartment);
  yield takeEvery(HIT_PT_DELETE_DEPARTEMENT, hitPtDeleteDepartment);
  yield takeEvery(HIT_PT_ADD_DEPARTMENT_MEMBER, postPtDepartmentMember);
  yield takeEvery(HIT_PT_TEAM_MANAGEMENT, getPtTeamManagement);
  yield takeEvery(HIT_PT_ADD_TEAM_MANAGEMENT, postPtTeamManagement);
  yield takeEvery(HIT_PT_ADD_TEAM_MEMBER, postPtTeamMember);
  yield takeEvery(HIT_PT_COMMENT, postPtComment);
  yield takeEvery(HIT_LIST_PROCESS, getListProcess);
  yield takeEvery(HIT_LIST_MEASURENMENT, getListMeasurenment);
  yield takeEvery(HIT_PT_OBJECTIVE_LIST, getListObjective);
  yield takeEvery(HIT_PT_KEYRESULT_LIST, getListKeyresult);
  yield takeEvery(HIT_PT_INITIATIVE_LIST, getListInitiative);
  yield takeEvery(HIT_PT_HIERARCHY, getPtHierarchy);
  yield takeEvery(HIT_TEMPORARY_ASSIGNMENT, postTemporaryAssignment);
  yield takeEvery(HIT_OKR_STATUS, getOkrStatus);
  yield takeEvery(HIT_UPDATE_PROGRESS, updateProgress);
}
// trigger commit production
